 console.log("Precheckout...");

// ============================================================
// UTM TRACKING
// ============================================================
function captureUTMs() {
    console.log("utm")
    const params = new URLSearchParams(window.location.search);
    const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'utm_id'];
    const utms = {};

    utmKeys.forEach(key => {
        const value = params.get(key);
        if (value) utms[key] = value;
    });

    if (Object.keys(utms).length > 0) {
        sessionStorage.setItem('utm_params', JSON.stringify(utms));
    }
}

function getStoredUTMs() {
    try {
        return JSON.parse(sessionStorage.getItem('utm_params')) || {};
    } catch (e) {
        return {};
    }
}

// ============================================================
// PARÁMETROS DE CHECKOUT (UTMs) + cupón del carrito
// ============================================================
// El cupón NO se puede pasar de forma confiable por la URL del checkout
// (/cart/c/<token>): ese permalink deriva del carrito, así que el cupón debe vivir
// DENTRO del carrito. Por eso se aplica en el cartCreate (input.discountCodes) y en la
// URL solo anexamos UTMs. getAppliedDiscountCode() lee el cupón del carrito nativo
// (objeto de cart.js / cart/update.js) para pasarlo al cartCreate.
function getAppliedDiscountCode(cart) {
    if (!cart) return null;
    const apps = cart.cart_level_discount_applications || [];
    const byCode = apps.find(a => a && a.type === 'discount_code' && a.title);
    if (byCode) return byCode.title;
    if (Array.isArray(cart.discount_codes) && cart.discount_codes.length) {
        const applied = cart.discount_codes.find(d => d && d.applicable !== false) || cart.discount_codes[0];
        return applied ? applied.code : null;
    }
    return null;
}

// Anexa los UTMs a la URL del checkout. Usa el separador correcto (? o &) según si
// la URL ya trae parámetros. (El cupón va en el cartCreate, no en la URL.)
function appendCheckoutParams(url) {
    const utms = getStoredUTMs();
    const params = Object.keys(utms).map(key => `${key}=${encodeURIComponent(utms[key])}`);
    if (!params.length) return url;
    const sep = (url.includes("?") || url.includes("&")) ? "&" : "?";
    return url + sep + params.join("&");
}

// Capturar UTMs al cargar cualquier página
captureUTMs();

// ============================================================
// CONFIGURACIÓN (desde window.PRECHECKOUT_CONFIG — ver home.liquid)
// Este archivo se copia TAL CUAL entre clientes; lo específico vive en la config.
// ============================================================
const CFG = window.PRECHECKOUT_CONFIG || {};
const APP_PROXY = CFG.appProxy || "apps/apolo-ubigeo-calculation";
const CHECKOUT_BASE = (CFG.checkoutBase || "").replace(/\/+$/, "");
const COUNTRY = CFG.country || "PE";

// ------------------------------------------------------------------------------------------
// CONFIG DE NEGOCIO (dispatch, documents, stock, gift, addressMapping)
// ------------------------------------------------------------------------------------------
// Estas viven en el BACKEND (?scope=settings) y son la fuente de verdad. El liquid solo aporta
// un FALLBACK: si el backend no envía el campo, se usa el de PRECHECKOUT_CONFIG. Por eso son
// `let`: arrancan con el fallback del liquid y applyBackendConfig() las sobreescribe al init.
// Los helpers derive* normalizan (boolean u objeto) y se reutilizan en ambos orígenes.
// Modos de retiro soportados. Cualquier valor desconocido cae a "stores", que es
// el comportamiento histórico: un backend que mande un modo nuevo no rompe una
// tienda con el JS viejo.
//   "disclaimer"  → solo el cartel; la sucursal se elige en el checkout de Shopify.
//   "stores"      → lista de apolo_stores (?scope=shop-addresses). Informativa.
//   "warehouses"  → puntos de retiro del catálogo de almacenes
//                   (?scope=pickup-locations), YA validados contra el stock de Apolo.
const PICKUP_MODES = ["disclaimer", "stores", "warehouses"];
function derivePickup(p) {
    if (p && typeof p === "object") {
        return {
            enabled: p.enabled !== false,
            mode: PICKUP_MODES.indexOf(p.mode) !== -1 ? p.mode : "stores",
            disclaimer: p.disclaimer || ""
        };
    }
    return { enabled: !!p, mode: "stores", disclaimer: "" };
}
// Modos de retiro que se procesan COMO DELIVERY: formulario completo (todos los campos
// del cliente), ruteo a "Envío" en el checkout y dirección "Retiro en <tienda>".
//   - "stores":     lista visual de apolo_stores; el stock sale del único location de Shopify.
//   - "warehouses": lista del catálogo de almacenes, filtrada por stock por sucursal.
// "disclaimer" NO entra: es retiro nativo (la sucursal se elige en el checkout de Shopify).
function isDeliveryLikePickup() {
    return PICKUP_CFG.mode === "stores" || PICKUP_CFG.mode === "warehouses";
}
// Recuadro para que el cliente escriba los datos de la agencia (metodos de tipo agencia):
// DOS campos, nombre y direccion, ambos editables. Apagado por defecto: un backend que no
// mande `dispatch.agency` deja todo como estaba. Si esta prendido, el recuadro aparece al
// elegir un metodo con `is_agency` y ambos valores pasan a ser obligatorios.
// Textos sobreescribibles desde la config; se aceptan las claves viejas (label/placeholder)
// como fallback del titulo y del placeholder de nombre, para no romper configs previas.
function deriveAgency(a) {
    const D = {
        enabled: false,
        heading: "Datos de la agencia",
        namePlaceholder: "Nombre de la agencia",
        addressPlaceholder: "Dirección de la agencia"
    };
    if (a && typeof a === "object") {
        return {
            enabled: a.enabled === true,
            heading: a.heading || a.label || D.heading,
            namePlaceholder: a.name_placeholder || a.placeholder || D.namePlaceholder,
            addressPlaceholder: a.address_placeholder || D.addressPlaceholder
        };
    }
    return D;
}
function deriveStock(s) { return (s === true) || !!(s && s.enabled === true); }
// Contra qué se valida la disponibilidad del carrito:
//   "shopify" → ?scope=stock, stock por location del canal. Default y correcto
//               cuando cada sucursal tiene su propio location: contempla ventas
//               que Apolo todavía no vio.
//   "apolo"   → ?scope=stock-local, el ledger por almacén. Necesario cuando varios
//               almacenes se publican SUMADOS en un mismo location: ahí Shopify solo
//               ve el total, y validar contra él es circular porque lo puso Apolo.
// Valor desconocido cae a "shopify": un backend nuevo no rompe un JS viejo.
function deriveStockSource(v) { return v === "apolo" ? "apolo" : "shopify"; }
// Cuándo mostrar el resumen de disponibilidad:
//   "always"     → apenas se valida (comportamiento histórico).
//   "on_problem" → solo si algún ítem del carrito no alcanza stock.
// Valor desconocido cae a "always": un backend nuevo no rompe un JS viejo.
function deriveStockSummaryMode(v) { return v === "on_problem" ? "on_problem" : "always"; }
function deriveGift(g)  { return (g === true) || !!(g && g.enabled === true); }
// Normaliza los avisos por zona a una lista de { prefix, text } usable.
// Se descarta lo que no sea objeto o venga sin prefijo, para que una config a medio
// escribir no rompa el render.
function normalizeAddressNotices(cfg) {
    const rules = (cfg && Array.isArray(cfg.rules)) ? cfg.rules : [];
    const out = [];
    for (const rule of rules) {
        if (!rule || typeof rule !== "object") continue;
        const prefix = String(rule.ubigeo_prefix || "").trim();
        if (!prefix) continue;
        out.push({ prefix: prefix, text: String(rule.text || "").trim() });
    }
    return out;
}
// Overrides de los placeholders de Dirección/Referencia por prefijo de ubigeo (independiente
// del método de envío). Forma: { rules: [{ ubigeo_prefix, address, reference }] }. Un campo
// omitido en la regla conserva el placeholder ORIGINAL del HTML (no lo pisa). Como en los
// avisos: gana la primera regla que matchea, "*" es comodín, y se descarta lo mal formado.
function normalizeAddressPlaceholders(cfg) {
    const rules = (cfg && Array.isArray(cfg.rules)) ? cfg.rules : [];
    const out = [];
    for (const rule of rules) {
        if (!rule || typeof rule !== "object") continue;
        const prefix = String(rule.ubigeo_prefix || "").trim();
        if (!prefix) continue;
        out.push({
            prefix: prefix,
            address:   typeof rule.address   === "string" ? rule.address   : null,
            reference: typeof rule.reference === "string" ? rule.reference : null
        });
    }
    return out;
}
function deriveDocCfg(documents) {
    return (documents && documents[COUNTRY]) || { person: [], company: null };
}

let DOC_CFG      = deriveDocCfg(CFG.documents);
let DISPATCH_CFG = Object.assign({ delivery: true, pickup: true }, CFG.dispatch || {});
let PICKUP_CFG   = derivePickup(DISPATCH_CFG.pickup);
let AGENCY_CFG   = deriveAgency(DISPATCH_CFG.agency);
let STOCK_ENABLED = deriveStock(CFG.stockValidation);
let STOCK_SOURCE  = deriveStockSource(CFG.stockSource);
let STOCK_SUMMARY_MODE = deriveStockSummaryMode(CFG.stockSummaryMode);
let GIFT_ENABLED  = deriveGift(CFG.gift);
// Avisos por zona del bloque de direccion, evaluados por prefijo de ubigeo.
// Forma: { rules: [{ ubigeo_prefix, text }] }. Lista vacia = no se muestra nada.
let ADDRESS_NOTICES = normalizeAddressNotices(CFG.addressNotices);
// Overrides de placeholders (Dirección/Referencia) por prefijo de ubigeo. Misma mecánica.
let ADDRESS_PLACEHOLDERS = normalizeAddressPlaceholders(CFG.addressPlaceholders);

// Ajustes generales servidos por el backend (?scope=settings). Se cargan al init;
// no viven en el liquid para que el cliente los cambie sin tocar el tema.
let PRECHECKOUT_SETTINGS = { min_purchase_amount: null, min_purchase_message: "" };
let CART_TOTAL = null;        // total del carrito CON descuentos (unidades, no centavos)
let CART_CURRENCY = "";       // ej. "PEN"

// ============================================================
// MAPEO DE CAMPOS → SHOPIFY CHECKOUT (deliveryAddress / MailingAddressInput)
// ------------------------------------------------------------
// Clave = campo de Shopify; valor = clave del atributo estándar que se envía ahí.
// Configurable por cliente (CFG.addressMapping): permite reasignar libremente, p.ej.
// mandar company_document a zip, o poner cualquier atributo en company. Se hace MERGE con
// el default, así el cliente solo sobreescribe lo que cambia; "" o null = no enviar el campo.
// Campos válidos de Shopify: firstName, lastName, phone, company, address1, address2,
//                            city, province, country, zip.
const DEFAULT_ADDRESS_MAPPING = {
    firstName: "first_name",
    lastName:  "last_name",
    phone:     "phone",
    province:  "region",
    city:      "province",
    address1:  "address",
    address2:  "reference",
    zip:       "ubigeo"
};
// `let`: fallback del liquid; applyBackendConfig() lo re-mergea si el backend envía addressMapping.
let ADDRESS_MAP = Object.assign({}, DEFAULT_ADDRESS_MAPPING, CFG.addressMapping || {});

// Sobreescribe la config de negocio con la que envía el backend en ?scope=settings. Cada campo
// es OPCIONAL: si no viene, se conserva el fallback del liquid. Así se migra la config al backend
// sin romper clientes cuyo backend aún no la sirva. Debe correr ANTES de armar el formulario.
function applyBackendConfig(data) {
    if (!data || typeof data !== "object") return;
    if (data.documents) DOC_CFG = deriveDocCfg(data.documents);
    if (data.dispatch) {
        DISPATCH_CFG = Object.assign({ delivery: true, pickup: true }, data.dispatch);
        PICKUP_CFG   = derivePickup(DISPATCH_CFG.pickup);
        AGENCY_CFG   = deriveAgency(DISPATCH_CFG.agency);
    }
    if (data.addressNotices) ADDRESS_NOTICES = normalizeAddressNotices(data.addressNotices);
    if (data.addressPlaceholders) ADDRESS_PLACEHOLDERS = normalizeAddressPlaceholders(data.addressPlaceholders);
    if (typeof data.stockValidation !== "undefined") STOCK_ENABLED = deriveStock(data.stockValidation);
    if (typeof data.stockSource !== "undefined")     STOCK_SOURCE  = deriveStockSource(data.stockSource);
    if (typeof data.stockSummaryMode !== "undefined") STOCK_SUMMARY_MODE = deriveStockSummaryMode(data.stockSummaryMode);
    if (typeof data.gift !== "undefined")            GIFT_ENABLED  = deriveGift(data.gift);
    if (data.addressMapping) ADDRESS_MAP = Object.assign({}, DEFAULT_ADDRESS_MAPPING, data.addressMapping);
}

// Teléfono a E.164 (Shopify lo exige en buyerIdentity/deliveryAddress).
function toE164(phone) {
    if (!phone) return phone;
    const p = String(phone).trim();
    return p.startsWith("+") ? p : `+51${p}`;
}

// Correlativo ISO para el campo province de Shopify.
function getProvinceCorrelatives(province) {
    switch (province) {
        case "Lima":
        case "LIMA":
            return "PE-LMA";
        default:
            return province;
    }
}

// ¿Tiene contenido útil el atributo? (undefined/null/"" cuentan como ausente)
function hasAttrValue(value) {
    return value !== undefined && value !== null && String(value).trim() !== "";
}

// Arma el deliveryAddress según el mapeo configurable. Aplica transforms por campo destino
// (province → correlativo ISO, phone → E.164). country cae al COUNTRY del config si no se mapea.
//
// El valor del mapeo admite dos formas:
//   "atributo"                → fuente única.
//   ["attr_a", "attr_b", …]   → CADENA DE FALLBACK: gana el primero que tenga valor.
// La cadena resuelve los casos condicionales sin lógica extra, apoyándose en que los atributos
// condicionales solo existen cuando aplican (p.ej. company_document solo se agrega en factura).
function buildDeliveryAddress(attributes) {
    const addr = {};
    for (const shopifyField in ADDRESS_MAP) {
        const mapping = ADDRESS_MAP[shopifyField];
        if (!mapping) continue;

        const candidates = Array.isArray(mapping) ? mapping : [mapping];
        const srcKey = candidates.find(key => key && hasAttrValue(attributes[key]));
        if (!srcKey) continue;

        let value = String(attributes[srcKey]).trim();
        if (shopifyField === "province") value = getProvinceCorrelatives(value);
        if (shopifyField === "phone")    value = toE164(value);
        addr[shopifyField] = value;
    }
    if (!addr.country) addr.country = COUNTRY;
    return addr;
}

/* ============================================================
 * ESQUEMA ESTÁNDAR DE ATRIBUTOS (note_attributes del pedido)
 * Estas son las MISMAS claves en localStorage, en el carrito y las que
 * recibe el backend. Snake_case en inglés = una sola fuente de verdad.
 * ------------------------------------------------------------
 * Contacto:     first_name, last_name, email, phone
 * Documento:    document_type (dni|ce…), document_number
 * Comprobante:  receipt_type (boleta|factura), company_document (RUC/RUT), company_name
 * Despacho:     dispatch_mode (delivery|pickup), shipping_method (regular|express|programmed),
 *               pickup_store, delivery_date, delivery_time
 * Dirección:    country (PE|CL|EC), region, province, district, ubigeo, address, reference
 * Mapeo a Shopify GraphQL: region→province, province→city, address→address1,
 *               reference→address2, ubigeo→zip
 * ============================================================ */


/* -------------------------------------------------------------------------
 * 1. CONSTANTES Y ALMACENAMIENTO LOCAL
 * ------------------------------------------------------------------------- */
const CUSTOMER_KEY = "customerData";

function setCustomerData(field, value) {
    let data = JSON.parse(localStorage.getItem(CUSTOMER_KEY)) || {};
    data[field] = value;
    localStorage.setItem(CUSTOMER_KEY, JSON.stringify(data));
}

function getCustomerData(field) {
    let data = JSON.parse(localStorage.getItem(CUSTOMER_KEY)) || {};
    return data[field] || null;
}

function getAllCustomerData() {
    return JSON.parse(localStorage.getItem(CUSTOMER_KEY)) || {};
}

function clearCustomerData() {
    localStorage.removeItem(CUSTOMER_KEY);
}

function setLocalStorageCustomerData() {
    setCustomerData("first_name", $("#enova-billing-name").val());
    setCustomerData("last_name", $("#enova-billing-lastName").val());
    setCustomerData("email", $("#enova-billing-email").val());
    setCustomerData("phone", $("#enova-billing-telefono").val());
    setCustomerData("document_type", $("#enova-billing-documento-type").val());
    setCustomerData("document_number", $("#enova-billing-documento-number").val());

    setCustomerData("shipping_method", $('input[name="enova-despacho-tipo"]:checked').val());
    setCustomerData("dispatch_mode", $('input[name="enova-despacho"]:checked').val());
    // Tienda de retiro elegida (por id del radio, que incluye el code del almacén),
    // para re-seleccionarla al volver del checkout. Se guarda SOLO si hay una marcada:
    // durante el restore, la tienda se re-selecciona async (tras renderizar la lista) y el
    // autosave corre ANTES; sin este guard sobreescribía el id con "" y se perdía la selección.
    const _pickupStoreId = $("input[name=enova-despacho-recojo-tienda-item]:checked").attr("id");
    if (_pickupStoreId) setCustomerData("pickup_store_id", _pickupStoreId);
    setCustomerData("region", $("#enova-carrito-block-despacho-shipping__departamento").val());
    setCustomerData("province", $("#enova-carrito-block-despacho-shipping__provincia").val());
    setCustomerData("district", $("#enova-carrito-block-despacho-shipping__distrito").val());

    setCustomerData("address", $("#enova-despacho-direccion").val());
    setCustomerData("reference", $("#enova-despacho-referencia").val());

    setCustomerData("receipt_type", $('input[name="enova-billing-doc"]:checked').val());
    setCustomerData("company_document", $("#enova-billing-doc-ruc").val() || "");
    setCustomerData("company_name", $("#enova-billing-doc-razonsocial").val() || "");

    const isGift = $("#enova-regalo-check").is(":checked");
    setCustomerData("is_gift", isGift);
    setCustomerData("gift_recipient_name", isGift ? ($("#enova-regalo-nombre").val() || "") : "");
    setCustomerData("gift_recipient_phone", isGift ? ($("#enova-regalo-telefono").val() || "") : "");
    setCustomerData("gift_message", isGift ? ($("#enova-regalo-dedicatoria").val() || "") : "");

    setCustomerData("loaded", false);
}

function setInitCustomerData() {
    const customerData = getAllCustomerData();
    if (Object.keys(customerData).length === 0) {
        if (window.ShopifyCustomer && window.ShopifyCustomer.logged_in) {
            $("#enova-billing-name").val(window.ShopifyCustomer.firstName);
            $("#enova-billing-lastName").val(window.ShopifyCustomer.lastName);
            $("#enova-billing-email").val(window.ShopifyCustomer.email);
        }
    } else {
        $("#enova-billing-name").val(getCustomerData("first_name"));
        $("#enova-billing-lastName").val(getCustomerData("last_name"));
        $("#enova-billing-email").val(getCustomerData("email"));
        $("#enova-billing-telefono").val(getCustomerData("phone"));
        $("#enova-billing-documento-type").val(getCustomerData("document_type"));
        $("#enova-billing-documento-number").val(getCustomerData("document_number"));

        let savedDispatchMode = getCustomerData("dispatch_mode");
        if (savedDispatchMode) {
            let $shippingRadio = $(`input[name="enova-despacho"][value="${savedDispatchMode}"]`);
            if ($shippingRadio.length) {
                $shippingRadio.prop('checked', true);
                $shippingRadio.closest('.enova-despacho-selector-item').click();
            }
        }

        if (savedDispatchMode == 'delivery') {
            $("#enova-despacho-shipping").css("display", "block");
            $("#enova-despacho-direccion").val(getCustomerData("address"));
            $("#enova-despacho-referencia").val(getCustomerData("reference"));
        } else {
            $("#enova-despacho-shipping").css("display", "none");
            $("#enova-despacho-recojo-tienda").css("display", "block");
        }

        let savedReceiptType = getCustomerData("receipt_type");
        if (savedReceiptType) {
            let $billingRadio = $(`input[name="enova-billing-doc"][value="${savedReceiptType}"]`);
            if ($billingRadio.length) {
                $billingRadio.prop('checked', true);
                $billingRadio.closest('.enova-billing-item').click();
            }
        }

        if (savedReceiptType == "factura") {
            // NO se fija display inline: el .click() de arriba ya dispara setFormBillingDoc,
            // que activa el bloque por clase. Un inline aquí ganaba sobre el CSS y dejaba el
            // bloque imposible de ocultar al cambiar a Boleta.
            $("#enova-billing-doc-ruc").val(getCustomerData("company_document"));
            $("#enova-billing-doc-razonsocial").val(getCustomerData("company_name"));
        }

        if (getCustomerData("is_gift") === true) {
            $("#enova-regalo-nombre").val(getCustomerData("gift_recipient_name"));
            $("#enova-regalo-telefono").val(getCustomerData("gift_recipient_phone"));
            $("#enova-regalo-dedicatoria").val(getCustomerData("gift_message"));
            $("#enova-regalo-check").prop("checked", true).trigger("change"); // revela el form
        }
    }
}

// Autosave: persiste el formulario MIENTRAS el usuario lo completa (no solo al pagar).
// Así, al volver del checkout (recarga o fallback), setInitCustomerData restaura lo último
// escrito: dirección, referencia, tienda de retiro, etc. Debounced para no escribir en cada
// tecla. `.val()` programático (el restore) NO dispara input/change, así que no hay bucle.
let _persistTimer = null;
function initPersistOnChange() {
    const main = document.querySelector(".enova-block-carrito-main");
    if (!main) return;
    const save = () => {
        clearTimeout(_persistTimer);
        _persistTimer = setTimeout(() => {
            try { setLocalStorageCustomerData(); } catch (e) { /* nunca romper el flujo */ }
        }, 500);
    };
    main.addEventListener("input", save);
    main.addEventListener("change", save);
}

/* -------------------------------------------------------------------------
 * 2. STOREFRONT API CLIENT & REDIRECCIÓN
 * ------------------------------------------------------------------------- */
// Inicialización del nuevo Storefront API Client Oficial de Shopify
const client = ShopifyStorefrontAPIClient.createStorefrontApiClient({
    storeDomain: CFG.storeDomain,
    apiVersion: CFG.apiVersion,
    publicAccessToken: CFG.storefrontToken,
    customFetchApi: window.fetch
});

async function populate(scope = "departaments", options) {
    try {
        let countrySelected = options.country;
        let departamentoSelected = options.departament;
        let provinceSelected = options.district;
        let urlBuilder = null;

        if(scope === "departaments") {
            urlBuilder = `?scope=departaments&country=${countrySelected}`;
        } else if (scope === "provinces") {
            urlBuilder = `?scope=provinces&country=${countrySelected}&departament=${departamentoSelected}`;
        } else if (scope === "distrits") {
            urlBuilder = `?scope=distrits&country=${countrySelected}&departament=${departamentoSelected}&province=${provinceSelected}`;
        }

        let departamentos = await fetch(`${window.Shopify.routes.root}${APP_PROXY}${ urlBuilder }`, {
            "method": "GET",
            "headers": { 'Content-Type': 'application/json' }
        })
        .then((res) => res.json())
        .then((response) => {
            let filteredResponse = response.filter((item) => {
                if("is_active" in item) {
                    return item.is_active;
                } else {
                    return item;
                }
            });
            return filteredResponse;
        })
        .then((response) => {
            console.log("response", response);
            return response;
        })
        .catch(error => console.error('Error:', error));

        console.log("UBIGEOS - ", scope, departamentos);
        return departamentos;

    } catch(err) {
         console.log("err", err);
         return err;
    }
}
 
/* ---- EXPANSIÓN DE BUNDLES (Shopify Bundles) ----------------------------------
 * cart.js devuelve UNA sola línea por bundle: la del producto "paquete", que no
 * tiene SKU propio. Sus componentes —los únicos que existen en el ledger de Apolo—
 * no aparecen en ninguna parte del carrito ajax (`item_components` es de Liquid, no
 * del Ajax Cart API), así que sin expandir, un pack quedaba fuera de la validación:
 * el ?skus= salía vacío y el resumen lo daba por "Sin información" (fail-open).
 *
 * Los componentes se resuelven contra la Storefront API (ProductVariant.components,
 * solo bundles FIJOS, que es lo que genera la app Shopify Bundles). NO hay flag de
 * config: el disparador es `requiresComponents` del propio variant, que ya es la
 * fuente de verdad de Shopify — duplicarlo en el backend crea dos interruptores que
 * se desincronizan el día que el comerciante arma su primer pack. Una tienda sin
 * bundles paga UNA request que responde requiresComponents:false en todas las líneas.
 */

// variant_id -> [{sku, quantity, title}]. Array vacío = no es bundle. Se memoiza para
// toda la sesión: el usuario alterna entre envío y retiro varias veces y el carrito no
// cambia, así que solo la PRIMERA validación paga la request.
const _bundleCache = {};

const BUNDLE_COMPONENTS_QUERY = `
    query BundleComponents($ids: [ID!]!) {
        nodes(ids: $ids) {
            ... on ProductVariant {
                id
                requiresComponents
                components(first: 50) {
                    nodes {
                        quantity
                        productVariant {
                            sku
                            product { title }
                        }
                    }
                }
            }
        }
    }
`;

// Resuelve y cachea los componentes de las variantes que aún no se consultaron.
// Fail-open: si la query falla NO se cachea nada, así el próximo intento reintenta en
// vez de dejar los packs sin validar por el resto de la sesión.
async function loadBundleComponents(variantIds) {
    const missing = [];
    variantIds.forEach(id => {
        const key = String(id);
        if (!(key in _bundleCache) && missing.indexOf(key) === -1) missing.push(key);
    });
    if (!missing.length) return;

    try {
        const response = await client.request(BUNDLE_COMPONENTS_QUERY, {
            variables: { ids: missing.map(id => `gid://shopify/ProductVariant/${id}`) }
        });
        if (response.errors || response.graphQLErrors) {
            throw new Error("Storefront API devolvió errores al leer componentes");
        }

        const found = {};
        ((response.data && response.data.nodes) || []).forEach(node => {
            if (!node || !node.id) return;
            const key = String(node.id).split("/").pop();
            const comps = (node.requiresComponents && node.components)
                ? (node.components.nodes || [])
                : [];
            found[key] = comps
                .map(c => ({
                    sku: (c.productVariant && c.productVariant.sku) || "",
                    quantity: Number(c.quantity) || 1,
                    title: (c.productVariant && c.productVariant.product && c.productVariant.product.title) || ""
                }))
                .filter(c => c.sku);
        });

        // Lo que la query resolvió como "no bundle" (o como id inexistente) se cachea
        // vacío: es una respuesta válida y no hay por qué volver a preguntarla.
        missing.forEach(key => { _bundleCache[key] = found[key] || []; });
    } catch (e) {
        console.warn("Precheckout: no se pudieron leer los componentes de los bundles", e);
    }
}

// Desglosa cada línea del carrito en las UNIDADES de stock que realmente consume:
// un producto normal aporta su propio SKU; un pack aporta los SKUs de sus componentes,
// multiplicados por la cantidad de packs (2 packs = 2 mochilas + 2 loncheras).
// `units` vacío = línea imposible de resolver (ni SKU propio ni componentes).
async function expandCartLines(items) {
    await loadBundleComponents(items.map(i => i.variant_id));
    return items.map(item => {
        const comps = _bundleCache[String(item.variant_id)] || [];
        const units = comps.length
            ? comps.map(c => ({ sku: c.sku, quantity: c.quantity * item.quantity }))
            : (item.sku ? [{ sku: item.sku, quantity: item.quantity }] : []);
        return Object.assign({}, item, { units, isBundle: comps.length > 0 });
    });
}

// Cantidad total requerida por SKU en TODO el carrito. Es imprescindible sumar antes
// de comparar: un mismo SKU puede venir suelto Y dentro de un pack, y validar cada
// línea por separado contra el mismo `available` aprobaría dos veces el mismo stock.
function buildSkuDemand(lines) {
    const demand = {};
    lines.forEach(line => {
        (line.units || []).forEach(u => {
            demand[u.sku] = (demand[u.sku] || 0) + u.quantity;
        });
    });
    return demand;
}

// Carrito normalizado para el modo "warehouses": ítems con título (para pintar el
// resumen) y el parámetro "SKU:CANT,..." que consume ?scope=pickup-locations. El
// parámetro se arma con la DEMANDA agregada (bundles ya expandidos), no línea a línea.
// Las líneas que no se pueden resolver se avisan por consola: quedan fuera de la
// validación de retiro.
async function getCartForPickup() {
    const res = await fetch(window.Shopify.routes.root + 'cart.js', { method: 'GET' });
    const cart = await res.json();
    setCartTotalsFromCart(cart);   // aprovecha la request para refrescar el total
    const rawItems = (cart.items || []).map(i => ({
        variant_id: i.variant_id,
        quantity: i.quantity,
        sku: i.sku || "",
        title: i.product_title || i.title || ""
    }));
    const items = await expandCartLines(rawItems);
    const sinResolver = items.filter(i => !i.units.length);
    if (sinResolver.length) {
        console.warn("Precheckout: hay ítems sin SKU ni componentes; no se pueden validar para retiro.",
                     sinResolver.map(i => i.title));
    }
    const demand = buildSkuDemand(items);
    const param = Object.keys(demand).map(sku => `${sku}:${demand[sku]}`).join(",");
    return { items, param };
}

// Consulta ?scope=pickup-locations. Devuelve la respuesta completa: `locations`
// alimenta la lista de tiendas y `cart` el resumen por producto.
async function fetchPickupData() {
    const { items, param } = await getCartForPickup();
    if (!param) return { items, locations: [], cart: { items: [], any_location_covers_all: false } };
    // include_unavailable=1: trae TODAS las tiendas de retiro, cada una con el
    // detalle `items[].ok` por SKU. Hace falta para saber si UNA sola tienda tiene
    // todos los componentes de un pack — `cart.items[].pickup_anywhere` solo dice
    // "existe en alguna", que para un pack no alcanza (se retira junto o no se retira).
    // El listado visible se sigue filtrando por `covers_cart` en fetchPickupWarehouses.
    const res = await fetch(
        `${window.Shopify.routes.root}${APP_PROXY}?scope=pickup-locations&items=${encodeURIComponent(param)}&include_unavailable=1`,
        { method: "GET", headers: { 'Content-Type': 'application/json' } }
    );
    const data = await res.json();
    return {
        items,
        locations: (data && Array.isArray(data.locations)) ? data.locations : [],
        cart: (data && data.cart) ? data.cart : { items: [], any_location_covers_all: false }
    };
}

// Puntos de retiro ya filtrados por el stock del carrito. El backend devuelve un
// shape compatible con el de shop-addresses (code, name, address, complement,
// department, province, distrit, ubigeo), así que el render es el mismo para los
// dos orígenes.
async function fetchPickupWarehouses() {
    // Solo las que cubren el carrito completo: el resto viene únicamente para poder
    // calcular el veredicto por línea, no para ofrecérselas al comprador.
    return (await fetchPickupData()).locations.filter(loc => loc && loc.covers_cart !== false);
}

async function getPickUpShopList(filter_zona = null) {
    jQuery(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--list").html("<p>Validando</p>");

    let shopsList;
    if (PICKUP_CFG.mode === "warehouses") {
        shopsList = await fetchPickupWarehouses()
            .catch(error => { console.error('Error:', error); return []; });
    } else {
        shopsList = await fetch(`${window.Shopify.routes.root}${APP_PROXY}?scope=shop-addresses`, {
            "method": "GET",
            "headers": { 'Content-Type': 'application/json' }
        })
        .then((res) => res.json())
        .then((response) => response)
        .catch(error => console.error('Error:', error));
    }

    // Cualquier fallo del endpoint deja la lista vacía en vez de romper el render.
    if (!Array.isArray(shopsList)) shopsList = [];

    console.log("lista de tiendas", shopsList);

    let list_stores_filtered = [];
    if(filter_zona) {
        list_stores_filtered = shopsList.filter((element) => {
            return element['department'] === filter_zona;
        });
        shopsList = list_stores_filtered;
    }

    // Sin puntos de retiro válidos hay que decirlo: si no, el bloque queda en
    // blanco y el comprador cree que se está cargando.
    if (!shopsList.length) {
        jQuery(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--list").html(
            PICKUP_CFG.mode === "warehouses"
                ? "<p class='enova-tiendas-vacio'>No hay tiendas con stock disponible para todos los productos de tu carrito.</p>"
                : "<p class='enova-tiendas-vacio'>No hay tiendas disponibles.</p>"
        );
        return shopsList;
    }

    // `|| ""` en todos los campos opcionales: los orígenes no traen exactamente el
    // mismo set y un undefined se imprimiría literal en el DOM, y de ahí pasaría a
    // los atributos de la orden (region/province/district/ubigeo).
    let templateBlockStoreList = "";
    for(let store of shopsList) {
        // Tag de precio del retiro (locker): solo si la tienda tiene el precio activado.
        // Si es 0 (o gratis por superar el límite del carrito) muestra "Gratis", igual que
        // el delivery; si el precio está desactivado no se muestra nada.
        const priceTag = storePickupPriceTag(store);
        let templateItemElement = `
            <label class="enova-carrito-block-despacho-recojo-tienda__list-tiendas--item" for="enova-despacho-recojo-tienda-item-${store.code}">
                <input type="radio" name="enova-despacho-recojo-tienda-item" id="enova-despacho-recojo-tienda-item-${store.code}" data-code="${store.code || ""}" data-price-enabled="${store.price_enabled ? "1" : "0"}" data-price="${store.price != null ? store.price : ""}" data-total-cart-enabled="${store.total_cart_enabled ? "1" : "0"}" data-total-cart-limit="${store.total_cart_limit != null ? store.total_cart_limit : ""}" data-departamento="${store.department || ""}" data-provincia="${store.province || ""}" data-distrito="${store.distrit || ""}" data-ubigeo="${store.ubigeo || ""}" />
                <div class="enova-carrito-block-despacho-recojo-tienda__list-tiendas--item__text">
                    <h3 class="enova-tienda-titulo">${store.name || ""}</h3>
                    <p class="enova-tienda-direccion">${store.address || ""}</p>
                    <p class="enova-tienda-complement">${store.complement || ""}</p>
                    ${priceTag}
                </div>
            </label>
        `;
        templateBlockStoreList += templateItemElement;
    }

    jQuery(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--list").html(templateBlockStoreList);

    setTimeout(() => {
        setStoresEventClick();
        // Restaura la tienda elegida previamente (si sigue disponible en la lista).
        const savedStoreId = getCustomerData("pickup_store_id");
        if (savedStoreId) {
            const input = document.getElementById(savedStoreId);
            if (input) {
                input.checked = true;
                const item = input.closest(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item");
                if (item) item.classList.add("active");
            }
        }
    }, 300);

    return shopsList;
}

async function getResponseCartItems(format = null) {
    let carritoItems = [];
    const responseCart = await fetch(window.Shopify.routes.root + 'cart.js', { method: 'GET' });
    const dataCart = await responseCart.json();
    // Refresca el total del carrito (con descuentos) desde este mismo fetch: lo usa el
    // scope=district-calc-rates (envío gratis sobre monto) y el pill de precio de retiro.
    setCartTotalsFromCart(dataCart);

    const utf8_to_b64 = (str) => window.btoa(unescape(encodeURIComponent(str)));

    for (let item of dataCart.items) {
        let varianIdEncoded64 = `gid://shopify/ProductVariant/${item.variant_id}`;
        
        let getUbigeoSelected = jQuery("#enova-carrito-block-despacho-shipping__distrito option:selected").data("ubigeo");
        let getShippingMethod = jQuery("input[name=enova-despacho-tipo]:checked").val();
        let getDespacho = jQuery("input[name=enova-despacho]:checked").val();
        // Normalizado al esquema estándar (delivery|pickup) que lee el CarrierService del backend.
        let getDispatchMode = getDespacho === "recojo-tienda" ? "pickup" : "delivery";

        let existingAttributes = [];
        if (item.properties) {
            existingAttributes = Object.entries(item.properties).map(([key, value]) => ({
                key: key,
                value: String(value)
            }));
        }

        // Claves _-prefijadas en snake_case (esquema estándar). El POST del backend (CarrierService)
        // lee _dispatch_mode y _shipping_method de aquí para resolver la tarifa del checkout nativo.
        // En retiro "warehouses" la descripción del método sale de la tienda elegida (fantasma).
        const _wh = getWarehousePickupInfo();
        let newAttributes = [
            { key: "_dispatch_mode", value: String(getDispatchMode) },
            { key: "_dispatch_mode_description", value: String(_wh ? _wh.desc : getDispatchModeDescription()) },
            { key: "_shipping_method", value: String(getShippingMethod) },
            { key: "_ubigeo", value: String(getUbigeoSelected) },
            { key: "_peso", value: String(item.grams) },
            // `|| ""`: el variant de un bundle no trae SKU y `String(null)` mandaba
            // literalmente "null" al CarrierService como si fuera un SKU válido.
            { key: "_sku", value: String(item.sku || "") }
        ];
        // Nombre del método: el backend arma "Retiro en <_pickup_title>". Va como line item
        // property OCULTA (prefijo "_") para que Shopify no la muestre en el checkout; igual llega
        // al CarrierService (los note_attributes del carrito no llegan, por eso va acá).
        if (_wh && _wh.title) {
            newAttributes.push({ key: "_pickup_title", value: String(_wh.title) });
        }
        // Código de la tienda (OCULTO, prefijo "_"): el CarrierService resuelve el Store por
        // este código y cobra su precio de retiro (locker).
        if (_wh && _wh.code) {
            newAttributes.push({ key: "_pickup_store_code", value: String(_wh.code) });
        }

        let combinedAttributes = [...existingAttributes, ...newAttributes];

        let lineItemsToAdd = {
            variantId: utf8_to_b64(varianIdEncoded64),
            quantity: item.quantity,
            attributes: combinedAttributes
        };

        if (format) {
            lineItemsToAdd['requires_shipping'] = true; 
        }

        carritoItems.push(lineItemsToAdd);
    }
    // Adjuntamos el cupón del mismo cart.js (evita un segundo fetch). El array sigue
    // siendo iterable normal; solo lleva además .discountCodes para el cartCreate.
    const discountCode = getAppliedDiscountCode(dataCart);
    carritoItems.discountCodes = discountCode ? [discountCode] : [];
    return carritoItems;
}

async function serviceCart2CheckoutStoreFrontAPI(cartAttributes) {
    try {
        let carritoItemsList = await getResponseCartItems();
        
        // Mapeo estructurado para los atributos personalizados del carrito
        let cartAttributesList = [];
        for (let cartKey in cartAttributes.attributes) {
            cartAttributesList.push({
                key: cartKey,
                value: String(cartAttributes.attributes[cartKey])
            });
        }

        // NUEVA MUTACIÓN: Usamos cartCreate (Válida en la API 2026)
        const cartCreateMutation = `
            mutation cartCreate($input: CartInput!) {
                cartCreate(input: $input) {
                    cart {
                        id
                        checkoutUrl
                    }
                    userErrors {
                        code
                        field
                        message
                    }
                }
            }
        `;

        // Cupón aplicado en el carrito nativo → se pasa al carrito de la Storefront API
        // (input.discountCodes). Es la forma confiable: viaja al checkout con el carrito,
        // no por la URL. Si el código es inválido, Shopify lo marca como no aplicable sin romper.
        // Ya viene resuelto desde getResponseCartItems (sin fetch extra).
        const discountCodes = carritoItemsList.discountCodes || [];

        // Modo de despacho → preferencia de entrega del checkout (abre la pestaña correcta).
        const isPickup = cartAttributes.attributes['dispatch_mode'] === 'pickup';
        // En modo "warehouses" el retiro NO va al pickup nativo de Shopify: se procesa como
        // delivery (pestaña "Envío") con la dirección "Retiro en <tienda>". Así el pedido lleva
        // todos los datos como un envío normal, apuntando a la tienda de retiro elegida.
        const routeAsDelivery = !isPickup || isDeliveryLikePickup();

        const buyerIdentity = {
            email: cartAttributes.attributes.email,
            phone: toE164(cartAttributes.attributes['phone']),
            // Preselecciona Envío (SHIPPING) o Retiro nativo (PICK_UP) en el checkout de Shopify.
            preferences: {
                delivery: {
                    deliveryMethod: [ routeAsDelivery ? "SHIPPING" : "PICK_UP" ]
                }
            }
        };

        // Mandamos deliveryAddress cuando el flujo va como envío (delivery real o retiro
        // "warehouses"). En el pickup NATIVO no: cualquier deliveryAddress empuja el checkout a
        // la pestaña "Envío". La Cart API no tiene billingAddress (no se puede prellenar ahí).
        if (routeAsDelivery) {
            buyerIdentity.deliveryAddressPreferences = [
                { deliveryAddress: buildDeliveryAddress(cartAttributes.attributes) }
            ];
        }

        const variables = {
            input: {
                attributes: cartAttributesList,
                ...(discountCodes.length ? { discountCodes } : {}),
                lines: carritoItemsList.map(item => ({
                    merchandiseId: item.variantId,
                    quantity: parseInt(item.quantity),
                    attributes: item.attributes
                })),
                buyerIdentity: buyerIdentity
            }
        };

        console.log("Ejecutando mutación cartCreate con variables:", variables);

        // Envío de la consulta mediante el nuevo SDK .request()
        const response = await client.request(cartCreateMutation, { variables });

        // Validación de errores adaptada al nuevo objeto Cart
        if (response.errors || response.graphQLErrors || (response.data && response.data.cartCreate.userErrors && response.data.cartCreate.userErrors.length > 0)) {
            let errorLog = response.graphQLErrors || response.errors || response.data?.cartCreate?.userErrors || [];
            console.error("--- DETALLE DE ERRORES DE SHOPIFY GRAPHQL ---");
            console.error(errorLog);
            console.error("---------------------------------------------");
            throw new Error(errorLog[0]?.message || "Error al procesar el Carrito en Shopify");
        }

        // Extraemos los datos del nuevo objeto de retorno
        const cartData = response.data.cartCreate.cart;
        console.log("Carrito creado satisfactoriamente en Shopify:", cartData);
        
        // Retornamos una simulación del objeto antiguo para no romper tu lógica de redirección del JS principal
        return { 
            checkout: { 
                id: cartData.id,
                webUrl: cartData.checkoutUrl // URL nativa de pasarela que incluye todos los datos pre-llenados
            } 
        };
        
    } catch(err) {
        console.log("Error crítico durante la creación del flujo de checkout:", err);
        checkoutButtonLoader(false);
        document.querySelector("#enova-message-carrito").textContent = "No se pudo iniciar el pago, por favor intente nuevamente en unos minutos.";
        document.querySelector("#enova-message-carrito").classList.add("active");
        return err;
    }
}

/* -------------------------------------------------------------------------
 * 3. LÓGICA Y REGLAS DE VALIDACIÓN
 * ------------------------------------------------------------------------- */
function validateDeliveryForm(objectForm) {
    let validated = true;
    for(let key in objectForm) {
        console.log("objectForm Value", objectForm[key]);
        if(!objectForm || objectForm[key] === '' || objectForm[key] === null) {
            validated = false;
        }
    }
    return validated;
}

function isCarritoProductTypeShipping(cartList) {
    let isCarritoReadyForShipping = false;
    
    for(let product of cartList) {
        let isShipping = product.requires_shipping;
        if(isShipping) {
            isCarritoReadyForShipping = true;
            break;
        }
    }

    if(cartList && cartList.length === 0) {
        isCarritoReadyForShipping = true;
    }

    return isCarritoReadyForShipping;
}

// Las fechas de envío programado ya NO se generan en el frontend: vienen del backend en
// `method.scheduling.days` y se pintan en renderSchedulingForMethod (formateadas con
// formatDeliveryDay). El backend maneja toda la lógica de días hábiles/feriados/cortes.

/* -------------------------------------------------------------------------
 * 4. UI / DOM UPDATES
 * ------------------------------------------------------------------------- */
function despachoMethodShippingLoading(status) {
    if (status === 'loading') {
        document.querySelector(".enova-despacho-shipping-loading").classList.add("active");
        document.querySelector(".enova-carrito-block-despacho-shipping-tipo__delivery").classList.remove("active");
        document.querySelector(".enova-carrito-block-despacho-shipping-tipo__delivery").classList.add("disabled");
    } else {
        document.querySelector(".enova-despacho-shipping-loading").classList.remove("active");
        document.querySelector(".enova-carrito-block-despacho-shipping-tipo__delivery").classList.add("active");
        document.querySelector(".enova-carrito-block-despacho-shipping-tipo__delivery").classList.remove("disabled");
    }
}

// Muestra/oculta un overlay suave de carga sobre el formulario del precheckout.
// Se crea una sola vez y se togglea con la clase .active.
function setPrecheckoutOverlay(show) {
    const container = document.querySelector(".enova-block-carrito-main");
    if (!container) return;
    let overlay = container.querySelector(".enova-loading-overlay");
    if (!overlay) {
        if (!show) return;  // nada que ocultar, no lo creamos por gusto
        overlay = document.createElement("div");
        overlay.className = "enova-loading-overlay";
        overlay.setAttribute("aria-hidden", "true");
        overlay.innerHTML = `
            <div class="enova-loading-overlay__box">
                <span class="enova-loading-overlay__spinner"></span>
                <span class="enova-loading-overlay__text">Procesando...</span>
            </div>`;
        container.appendChild(overlay);
    }
    overlay.classList.toggle("active", !!show);
}

function checkoutButtonLoader(status) {
    setPrecheckoutOverlay(!!status);
    const btn = document.querySelector("#enova_cart-data-submit");
    if (!btn) return;  // el botón aún no ha sido inyectado
    if(status) {
        jQuery(".loader-button__text_container .loader-button__text").text("Cargando...");
        btn.setAttribute("aria-busy", "true");
        jQuery(btn).css({ "pointer-events": 'none', "opacity": '.5' });
    } else {
        jQuery(".loader-button__text_container .loader-button__text").text("Ir a Pagar");
        btn.setAttribute("aria-busy", "false");
        // Re-habilita solo si el stock NO está bloqueando el checkout
        if (!_stockBlocked) {
            jQuery(btn).css({ "pointer-events": 'initial', "opacity": '1' });
        }
    }
}

// Bloqueo del checkout por falta de stock (solo cuando la validación está activa).
// El botón queda deshabilitado hasta que el método elegido tenga disponibilidad.
let _stockBlocked = false;
function setCheckoutBlockedByStock(blocked) {
    _stockBlocked = !!blocked;
    const btn = document.querySelector("#enova_cart-data-submit");
    if (!btn) return;  // el botón aún no existe; se re-aplica al inyectarlo
    btn.setAttribute("aria-disabled", _stockBlocked ? "true" : "false");
    btn.classList.toggle("is-stock-blocked", _stockBlocked);
    jQuery(btn).css({
        "pointer-events": _stockBlocked ? "none" : "initial",
        "opacity": _stockBlocked ? ".5" : "1"
    });
}

function setResetSelectorOptions(scope, addressBilling = null) {
    let templateList = `<option value="">Seleccione...</option>`;
    if(scope === "departaments") {
        if(addressBilling) {
            jQuery("#enova-carrito-block-despacho-billing__departamento").html(templateList);
        } else {
            jQuery("#enova-carrito-block-despacho-shipping__departamento").html(templateList);
        }
    } else if(scope === "provinces") {
        if(addressBilling) {
            jQuery("#enova-carrito-block-despacho-billing__provincia").html(templateList);
        } else {
            jQuery("#enova-carrito-block-despacho-shipping__provincia").html(templateList);
        }
    } else if (scope === "distrits") {
        if(addressBilling) {
            jQuery("#enova-carrito-block-despacho-billing__distrito").html(templateList);
        } else {
            jQuery("#enova-carrito-block-despacho-shipping__distrito").html(templateList);
        }
    }
}

function setSelectorOptions(scope, optionList, addressBilling = null) {
    let templateList = '<option>Seleccione...</option>';
    for(let optionUbigeo of optionList) {
        let itemOptionTemplate = `
            <option value="${optionUbigeo.name}" data-ubigeo="${optionUbigeo.code}" data-code="${optionUbigeo.code}" data-id="${optionUbigeo.id}">${optionUbigeo.name}</option>
        `;
        templateList += itemOptionTemplate;
    }
    
    if(scope === "departaments") {
        if(addressBilling) {
            jQuery("#enova-carrito-block-despacho-billing__departamento").html(templateList);
        } else {
            jQuery("#enova-carrito-block-despacho-shipping__departamento").html(templateList);
        }
    } else if(scope === "provinces") {
        if(addressBilling) {
            jQuery("#enova-carrito-block-despacho-billing__provincia").html(templateList);
        } else {
            jQuery("#enova-carrito-block-despacho-shipping__provincia").html(templateList);
        }
    } else if (scope === "distrits") {
        if(addressBilling) {
            jQuery("#enova-carrito-block-despacho-billing__distrito").html(templateList);
        } else {
            jQuery("#enova-carrito-block-despacho-shipping__distrito").html(templateList);
        }
    }
}

// Locale para las fechas visibles, derivado del país del config (PE→es-PE, CL→es-CL…).
const DELIVERY_LOCALE = `es-${COUNTRY}`;

// Formatea una fecha civil ISO (YYYY-MM-DD) a "Miércoles, 22 de julio de 2026".
// timeZone:'UTC' es CLAVE: new Date("YYYY-MM-DD") es medianoche UTC; sin fijar UTC al
// formatear, en un timezone detrás de UTC (Perú = -5) se corre al día anterior. El día de
// la semana de una fecha civil es independiente del timezone, así que no se necesita el TZ
// de la company aquí (ese solo importa en el backend, que ya decide QUÉ días ofrecer).
function formatDeliveryDay(iso) {
    const parts = String(iso).split('-').map(Number);
    if (parts.length !== 3 || parts.some(isNaN)) return iso;
    const [y, m, d] = parts;
    const date = new Date(Date.UTC(y, m - 1, d));
    const txt = new Intl.DateTimeFormat(DELIVERY_LOCALE, {
        weekday: 'long', day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC'
    }).format(date);
    return txt.charAt(0).toUpperCase() + txt.slice(1);
}

// Precio visible de las tarifas: formato moneda con 2 decimales (ej. 8 → "S/ 8.00").
// El backend puede mandar el precio como number o string; se normaliza y, si no es un
// número válido, cae a 0.00 en vez de imprimir "NaN".
function formatShippingPrice(value) {
    const amount = Number(value);
    return `S/ ${(Number.isFinite(amount) ? amount : 0).toFixed(2)}`;
}

// Tag de precio del retiro por tienda/locker. Espeja la lógica del delivery:
//   - precio desactivado (price_enabled falso)  -> sin tag (string vacío)
//   - gratis (precio 0, o carrito supera el límite con total_cart_enabled) -> "Gratis"
//   - en otro caso -> "S/ X.XX"
// La autoridad del cobro real es el CarrierService del backend; esto es solo visual.
function storePickupPriceTag(store) {
    if (!store || !store.price_enabled) return "";
    let free = Number(store.price) === 0;
    if (
        store.total_cart_enabled &&
        CART_TOTAL !== null &&
        CART_TOTAL > Number(store.total_cart_limit)
    ) {
        free = true;
    }
    const label = free ? "Gratis" : formatShippingPrice(store.price);
    return `<p class="enova-tienda-precio">${label}</p>`;
}

// Métodos de despacho de la última consulta (por code) para poder leer su `scheduling`
// cuando el usuario elige un método sin volver a consultar el backend.
let _shippingMethodsByCode = {};

// Config de fecha/horario del método, según el contrato estándar `scheduling`.
// Devuelve { days, windows, windowsByDay } o null si el método no la requiere
// (presence-based). `windowsByDay` es opcional: el backend solo la manda para los días
// cuyas ventanas difieren de las generales (hoy, cuando ya pasó parte del día).
function getMethodScheduling(method) {
    const s = method && method.scheduling;
    if (!s || !Array.isArray(s.days) || !s.days.length) return null;
    return {
        days: s.days,
        windows: Array.isArray(s.windows) ? s.windows : [],
        windowsByDay: (s.windows_by_day && typeof s.windows_by_day === "object")
            ? s.windows_by_day : {},
    };
}

// Ventanas horarias del día elegido: las específicas si el backend las mandó para esa
// fecha, las generales si no.
function getWindowsForDay(scheduling, iso) {
    const specific = scheduling.windowsByDay[iso];
    return Array.isArray(specific) ? specific : scheduling.windows;
}

// Descripción del método de despacho que viaja al checkout en `_dispatch_mode_description`.
// El backend la usa como `description` de la tarifa en el POST del CarrierService.
//  - Programado (con scheduling): frase armada con el día y horario elegidos.
//  - Resto de métodos: la descripción del backend ya resuelta (post display_rules).
//  - Retiro en tienda: vacío (el backend arma su propio texto de recojo).
function getDispatchModeDescription() {
    const dispatchChecked = document.querySelector("input[name=enova-despacho]:checked");
    if (!dispatchChecked || dispatchChecked.value === "recojo-tienda") return "";

    const checkedTipo = document.querySelector("input[name=enova-despacho-tipo]:checked");
    const method = checkedTipo ? _shippingMethodsByCode[checkedTipo.value] : null;
    if (!method) return "";

    if (getMethodScheduling(method)) {
        const selFecha   = document.querySelector("#enova-despacho-delivery-select-fecha");
        const selHorario = document.querySelector("#enova-despacho-delivery-select-horario");
        const diaISO  = selFecha ? selFecha.value : "";
        const horario = selHorario ? selHorario.value : "";
        if (diaISO) {
            // El horario es opcional (hay días sin ventanas): se anexa solo si existe.
            return horario
                ? `Tu pedido llegará el ${formatDeliveryDay(diaISO)} en el horario de ${horario}`
                : `Tu pedido llegará el ${formatDeliveryDay(diaISO)}`;
        }
    }

    return method.effective_description || method.description || "";
}

// Info de la tienda elegida en retiro "warehouses". Se manda al CarrierService como line item
// properties (los note_attributes del carrito NO llegan al carrier):
//   - `_pickup_title` (OCULTA, prefijo "_"): el backend arma el nombre "Retiro en <title>".
//   - la descripción va en `_dispatch_mode_description` (FANTASMA): el backend la usa como
//     descripción del método (services.py -> dispatch_mode_description).
// Retorna null si no aplica (no es retiro, no es modo warehouses, o no hay tienda elegida).
function getWarehousePickupInfo() {
    const despacho = document.querySelector("input[name=enova-despacho]:checked");
    if (!despacho || despacho.value !== "recojo-tienda" || !isDeliveryLikePickup()) return null;
    const si = document.querySelector(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item input:checked");
    if (!si) return null;
    const $s = jQuery(si).parent();
    const title = ($s.find(".enova-tienda-titulo").text() || "").trim();
    const dir   = ($s.find(".enova-tienda-direccion").text() || "").trim();
    const comp  = ($s.find(".enova-tienda-complement").text() || "").trim();
    const addr  = [dir, comp].filter(Boolean).join(" ");
    return {
        title,
        // Código de la tienda: el CarrierService lo usa para resolver el Store y
        // cobrar su precio de retiro (locker).
        code: (jQuery(si).data("code") || "").toString().trim(),
        // Solo la dirección: el nombre del método ya lleva "Retiro en <title>",
        // no hace falta repetir el título en la descripción.
        desc: addr,
    };
}

// Pinta el select de horarios con las ventanas del día `iso`, restaurando `prevWindow`
// si ese horario sigue disponible en el nuevo día.
function renderWindowsForDay(scheduling, iso, prevWindow) {
    const selHorario = document.querySelector("#enova-despacho-delivery-select-horario");
    const block = document.querySelector(".enova-carrito-block-despacho-shipping__fecha");
    if (!selHorario) return;

    const windows = getWindowsForDay(scheduling, iso);
    const hasWindows = windows.length > 0;

    // Sin ventanas para ESTE día: se oculta el slot de horario (la fecha pasa a ancho completo
    // vía .no-windows) y el horario deja de ser obligatorio en el submit. Se hace por día
    // porque un día puede tener ventanas y otro no (p.ej. hoy ya empezó y no quedan cortes).
    if (block) block.classList.toggle("no-windows", !hasWindows);

    if (!hasWindows) {
        selHorario.innerHTML = '';   // vacío → value "" → la validación no lo exige
        return;
    }

    let opts = '';
    const labels = [];
    windows.forEach(w => {
        const label = (w.label || `${w.start} - ${w.end}`).trim();
        labels.push(label);
        opts += `<option value="${label}">${label}</option>`;
    });
    selHorario.innerHTML = opts;
    if (prevWindow && labels.indexOf(prevWindow) !== -1) selHorario.value = prevWindow;
}

// ¿El método elegido pide el nombre de la agencia?
// Presence-based igual que `scheduling`: el backend marca el método con `is_agency` y la
// config decide si la funcionalidad está prendida. El JS no compara contra "agency".
function methodNeedsAgencyName(method) {
    return !!(AGENCY_CFG.enabled && method && method.is_agency);
}

// Muestra u oculta el recuadro de la agencia (nombre + dirección) según el método elegido.
// Al ocultarlo se limpian ambos valores: si el cliente cambia de agencia a regular, lo
// tecleado no debe viajar al checkout.
function renderAgencyForMethod(method) {
    const block    = document.querySelector(".enova-carrito-block-despacho-shipping__agencia");
    const inpName  = document.querySelector("#enova-despacho-agencia-nombre");
    const inpAddr  = document.querySelector("#enova-despacho-agencia-direccion");
    if (!block) return;

    if (!methodNeedsAgencyName(method)) {
        block.classList.remove("active");
        [inpName, inpAddr].forEach(el => {
            if (el) { el.value = ""; el.classList.remove("input-has-error"); }
        });
        return;
    }

    const label = document.querySelector("#enova-despacho-agencia-label");
    if (label)   label.textContent = AGENCY_CFG.heading;
    if (inpName) inpName.placeholder = AGENCY_CFG.namePlaceholder;
    if (inpAddr) inpAddr.placeholder = AGENCY_CFG.addressPlaceholder;
    block.classList.add("active");
}

// Código de ubigeo MÁS ESPECÍFICO ya elegido: distrito > provincia > departamento.
// Así una regla corta ("15") aplica apenas se elige el departamento y una larga
// ("150101") recién cuando hay distrito, sin necesitar configurar a qué nivel mirar.
function getSelectedUbigeoCode() {
    const ids = [
        "#enova-carrito-block-despacho-shipping__distrito",
        "#enova-carrito-block-despacho-shipping__provincia",
        "#enova-carrito-block-despacho-shipping__departamento"
    ];
    for (const id of ids) {
        const opt = document.querySelector(id + " option:checked");
        const code = opt ? (opt.dataset.ubigeo || opt.dataset.code || "") : "";
        if (code) return String(code).trim();
    }
    return "";
}

// Pinta el aviso de la zona elegida. Gana la PRIMERA regla que matchea por prefijo;
// "*" matchea siempre y sirve de comodín final. Texto vacío = se oculta el bloque, que
// es como se expresa "esta zona no lleva aviso".
function renderAddressNotice() {
    const block = document.querySelector("#enova-despacho-aviso-zona");
    if (!block) return;

    const code = getSelectedUbigeoCode();
    let text = "";
    if (code && ADDRESS_NOTICES.length) {
        const matched = ADDRESS_NOTICES.find(
            r => r.prefix === "*" || code.startsWith(r.prefix)
        );
        if (matched) text = matched.text;
    }

    block.innerHTML = text;
    block.classList.toggle("active", !!text);
}

// Placeholders originales del HTML, capturados UNA vez para poder revertir cuando la zona
// elegida no tiene regla (o el cliente cambia de una zona con override a una sin él).
let _addrPlaceholderDefaults = null;

// Ajusta los placeholders de Dirección/Referencia según el ubigeo elegido (mismo criterio
// de match que el aviso por zona). Sin regla que matchee → placeholders por defecto del HTML.
function renderAddressPlaceholders() {
    const inpAddr = document.querySelector("#enova-despacho-direccion");
    const inpRef  = document.querySelector("#enova-despacho-referencia");
    if (!inpAddr && !inpRef) return;

    if (!_addrPlaceholderDefaults) {
        _addrPlaceholderDefaults = {
            address:   inpAddr ? (inpAddr.getAttribute("placeholder") || "") : "",
            reference: inpRef  ? (inpRef.getAttribute("placeholder")  || "") : ""
        };
    }

    let addr = _addrPlaceholderDefaults.address;
    let ref  = _addrPlaceholderDefaults.reference;

    const code = getSelectedUbigeoCode();
    if (code && ADDRESS_PLACEHOLDERS.length) {
        const matched = ADDRESS_PLACEHOLDERS.find(
            r => r.prefix === "*" || code.startsWith(r.prefix)
        );
        if (matched) {
            if (matched.address   !== null) addr = matched.address;   // campo omitido → default
            if (matched.reference !== null) ref  = matched.reference;
        }
    }

    if (inpAddr) inpAddr.setAttribute("placeholder", addr);
    if (inpRef)  inpRef.setAttribute("placeholder", ref);
}

// Puebla y muestra el bloque de fecha/horario a partir de la config del método.
// Presence-based: si el método NO trae config de scheduling, el bloque se oculta. Así el
// backend decide qué método es "programado" sin acoplar el frontend a un code fijo.
function renderSchedulingForMethod(method) {
    const block      = document.querySelector(".enova-carrito-block-despacho-shipping__fecha");
    const selFecha   = document.querySelector("#enova-despacho-delivery-select-fecha");
    const selHorario = document.querySelector("#enova-despacho-delivery-select-horario");
    if (!block) return;

    const scheduling = getMethodScheduling(method);
    if (!scheduling) {
        block.classList.remove("active");
        $(block).css("display", "none");
        return;
    }

    // Se guarda lo ya elegido para restaurarlo tras repintar: esta función se re-ejecuta al
    // volver de "retiro en tienda", y sin esto la selección del cliente se perdía.
    const prevDay    = selFecha   ? selFecha.value   : "";
    const prevWindow = selHorario ? selHorario.value : "";

    // Días → value = ISO (lo que se manda al backend como delivery_date); texto = localizado.
    if (selFecha) {
        let opts = '';
        scheduling.days.forEach(iso => {
            opts += `<option value="${iso}">${formatDeliveryDay(iso)}</option>`;
        });
        selFecha.innerHTML = opts;
        // Restaura la elección previa solo si ese día sigue ofertándose; si no, queda el 1º.
        if (prevDay && scheduling.days.indexOf(prevDay) !== -1) selFecha.value = prevDay;
    }

    // Ventanas horarias del día seleccionado. Se repintan al cambiar la fecha porque hoy
    // puede ofrecer menos ventanas que el resto (las que ya empezaron no se agendan).
    if (selHorario) {
        renderWindowsForDay(scheduling, selFecha ? selFecha.value : "", prevWindow);
        if (selFecha) {
            selFecha.onchange = function () {
                renderWindowsForDay(scheduling, selFecha.value, selHorario.value);
            };
        }
    }

    // Se limpia el display inline (lo pone en "none" el change de distrito) para que mande
    // la regla CSS `.enova-carrito-block-despacho-shipping__fecha.active { display: flex }`.
    // Forzar "block" inline rompería el layout de 2 columnas (fecha | horario).
    block.classList.add("active");
    $(block).css("display", "");
}

function SetRenderShippingMethodsListOption(methodsList) {
    let templateList = '';
    let ubigeo = '';
    try {
        ubigeo = jQuery("#enova-carrito-block-despacho-shipping__distrito option:selected").data("ubigeo").toString();
    } catch (e) {}
    const horaActual = new Date().getHours();

    _shippingMethodsByCode = {};
    for (let method of methodsList) {
        _shippingMethodsByCode[method.code] = method;
        let description = method.description || '';
        let methodName = method.name || '';

        if (method.display_rules && method.display_rules.rules && method.display_rules.rules.length > 0) {
            const matchedRule = method.display_rules.rules.find(rule => {
                if (rule.ubigeo_prefix === '*') return true;
                return ubigeo.startsWith(rule.ubigeo_prefix);
            });

            if (matchedRule) {
                if (matchedRule.cutoff_hour && matchedRule.before_cutoff && matchedRule.after_cutoff) {
                    description = horaActual < matchedRule.cutoff_hour
                        ? matchedRule.before_cutoff
                        : matchedRule.after_cutoff;
                } else {
                    description = matchedRule.default
                }

                if (matchedRule.override_name) {
                    methodName = matchedRule.override_name;
                }
            }
        }

        // Descripción YA resuelta (post display_rules): es la que ve el cliente y la que
        // viaja al checkout en _dispatch_mode_description.
        method.effective_description = description;

        let templateItem = `
            <div class="enova-carrito-block-despacho-shipping-tipo__delivery--method">
                <input type="radio" name="enova-despacho-tipo" class="enova-delivery-method-1" id="enova-delivery-method-${method.code}" value="${method.code}">
                <label for="enova-delivery-method-${method.code}" class="enova-shipping-tipo__delivery-label enova-shipping-tipo__delivery--method1">
                    <div class="enova-shipping-method-tag-name-title">
                        <span class="enova-shipping-method-title">${methodName} </span>
                        <span class="enova-shipping-method-cost">
                            ${method.is_free_shipping ? 'Gratis' : formatShippingPrice(method.price)}
                        </span>
                    </div>
                    <div class="enova-shipping-method-tag-description">
                        <p>${description}</p>
                    </div>
                </label>
            </div>
        `;
        templateList += templateItem;
    }
    
    jQuery(".enova-carrito-block-despacho-shipping-tipo__delivery--list").html(templateList);
    calculateShippingMethodToShowOption();
}

function setFakeButtonCart() {
    let templateButtonCart = `
        <div class="enova_terms_conditions_block">
            <label class="enova_terms_conditions_block_terms" for="terms_conditions" style="display: flex;flex-direction: row;align-content: inherit;align-items: baseline;">
                <input type="checkbox" id="terms_conditions"/>
                <p class="enova_terms_text" style="margin-left: 10px;">He leído y acepto los <a href="/policies/terms-of-service">Términos y Condiciones</a> de compra del sitio web.</p>
            </label>
        </div>
        <div id="enova_cart-data-submit" is="loader-button" class="cart__checkout-button checkout-button button button--primary button--full">
            <span class="loader-button__text_container">
            <span class="loader-button__text">
                        <span class="checkout-button__lock"><svg focusable="false" width="17" height="17" class="icon icon--lock   " viewBox="0 0 17 17">
                <path d="M2.5 7V15H14.5V7H2.5Z" stroke="currentColor" stroke-width="1.5" fill="none"></path>
                <path d="M5.5 4C5.5 2.34315 6.84315 1 8.5 1V1C10.1569 1 11.5 2.34315 11.5 4V7H5.5V4Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"></path>
                <circle cx="8.5" cy="11" r="0.5" stroke="currentColor"></circle>
            </svg></span>Ir a pagar</span>
            <span class="loader-button__loader" hidden="">
                <div class="spinner">
                <svg focusable="false" width="24" height="24" class="icon icon--spinner" viewBox="25 25 50 50">
                    <circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" stroke-width="5"></circle>
                </svg>
                </div>
            </span>
            </span>
            <span class="loader-button__loader" hidden="">
                <div class="spinner">
                <svg focusable="false" width="24" height="24" class="icon icon--spinner" viewBox="25 25 50 50">
                    <circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" stroke-width="5"></circle>
                </svg>
                </div>
            </span>
        </div>
    `;

    if(document.querySelector(".cart__recap")) {
        document.querySelector(".cart__recap").innerHTML += templateButtonCart;
    } else {
        jQuery(".enova-carrito-block").after(templateButtonCart);
    }

    const submitBtn = document.querySelector("#enova_cart-data-submit");
    if(submitBtn) {
        submitBtn.addEventListener("click", handleCheckoutSubmit);
        // El botón se inyecta después de la validación de stock: aplica el estado actual
        setCheckoutBlockedByStock(_stockBlocked);
    }
}

/* -------------------------------------------------------------------------
 * 5. EVENTOS DE FORMULARIOS
 * ------------------------------------------------------------------------- */
// Muestra/oculta las opciones de despacho según PRECHECKOUT_CONFIG.dispatch.
// Si solo una queda habilitada, la selecciona y dispara su lógica automáticamente.
function applyDispatchConfig() {
    const deliveryInput = document.querySelector("#enova-despacho-delivery-option");
    const pickupInput   = document.querySelector("#enova-despacho-recojo-tienda-option");
    const deliveryLabel = deliveryInput ? deliveryInput.closest(".enova-despacho-selector-item") : null;
    const pickupLabel   = pickupInput ? pickupInput.closest(".enova-despacho-selector-item") : null;

    if (deliveryLabel) deliveryLabel.style.display = DISPATCH_CFG.delivery ? "" : "none";
    if (pickupLabel)   pickupLabel.style.display   = PICKUP_CFG.enabled   ? "" : "none";

    const enabled = [];
    if (DISPATCH_CFG.delivery && deliveryInput) enabled.push(deliveryInput);
    if (PICKUP_CFG.enabled    && pickupInput)   enabled.push(pickupInput);

    // Con UNA sola opción no hay elección real: se preselecciona y se dispara su click
    // (muestra el bloque correcto). Además se oculta el selector completo (título + botones)
    // vía .is-single-dispatch — un radio group de una sola opción es ruido: pide una decisión
    // que no existe, y el contexto no se pierde porque la sección siguiente ya lo dice
    // ("Dirección de envío" / "Elige un lugar de retiro").
    //
    // OJO: el ocultamiento es SOLO VISUAL. El input queda `checked`, así que dispatch_mode y
    // todo lo que depende de él (note_attributes, _dispatch_mode del line item, validación)
    // siguen funcionando exactamente igual.
    const isSingleDispatch = enabled.length === 1;
    if (isSingleDispatch) {
        enabled[0].checked = true;
        const label = enabled[0].closest(".enova-despacho-selector-item");
        if (label) label.click();
    }
    const main = document.querySelector(".enova-block-carrito-main");
    if (main) main.classList.toggle("is-single-dispatch", isSingleDispatch);

    // El divisor superior de cada sección se dibuja con `:not(:first-child)`, que es
    // ESTRUCTURAL: el título de despacho oculto sigue ocupando el primer lugar, así que el
    // siguiente heredaría una línea suelta arriba del formulario. Se marca a mano cuál es el
    // primer título realmente visible. Se hace en JS (y no con selectores de hermano) porque
    // el resumen de stock se inyecta en medio y rompería cualquier cadena de adyacencia.
    const titles = document.querySelectorAll(".enova-block-carrito-main .enova-carrito-block-title");
    titles.forEach(t => t.classList.remove("is-first-visible"));
    if (isSingleDispatch) {
        const firstVisible = Array.from(titles).find(t => t.id !== "despacho-title");
        if (firstVisible) firstVisible.classList.add("is-first-visible");
    }
}

// Muestra el bloque "¿Es un regalo?" solo si está habilitado en la config (CFG.gift).
function applyGiftConfig() {
    const block = document.querySelector("#enova-regalo-block");
    if (block) block.style.display = GIFT_ENABLED ? "" : "none";
}

// Toggle del destinatario (progressive disclosure): revela/oculta los campos según el
// checkbox. Al desmarcar limpia los inputs y sus errores, para que no se envíen ni bloqueen
// la validación. Aplica igual en delivery y pickup (el bloque es general, no anidado).
function setFormGift() {
    const check = document.querySelector("#enova-regalo-check");
    const form  = document.querySelector("#enova-regalo-form");
    if (!check || !form) return;
    const sync = () => {
        if (check.checked) {
            form.style.display = "block";
        } else {
            form.style.display = "none";
            $("#enova-regalo-nombre").val("").removeClass("input-has-error");
            $("#enova-regalo-telefono").val("").removeClass("input-has-error");
            $("#enova-regalo-dedicatoria").val("");
            $("#enova-regalo-telefono").parent().find(".text-has-error.text-gift-phone").remove();
        }
    };
    // Se bindea con jQuery (NO addEventListener): el restore hace .trigger("change"), que solo
    // ejecuta handlers de jQuery — no los nativos (jQuery únicamente invoca el método nativo del
    // elemento como acción por defecto, y `elem.change()` no existe). Con addEventListener el
    // checkbox quedaba marcado pero el bloque de destinatario no se revelaba al precargar.
    // El binding de jQuery igual responde al click real del usuario.
    jQuery(check).off("change.enovaGift").on("change.enovaGift", sync);
    sync(); // estado inicial (respeta lo restaurado desde localStorage)
}

// Renderiza el contenido del bloque de recojo según PICKUP_CFG.mode:
//  - "stores":     lista de tiendas del proxy (comportamiento normal).
//  - "warehouses": puntos de retiro del catálogo de almacenes, filtrados por stock.
//  - "disclaimer": muestra el HTML de PICKUP_CFG.disclaimer en vez de la lista.
function renderPickupMode() {
    const block = document.querySelector("#enova-despacho-recojo-tienda");
    if (!block) return;
    const listSection  = block.querySelector(".enova-carrito-block-despacho-recojo-tienda__list-tiendas");
    let disclaimerEl   = block.querySelector(".enova-carrito-block-despacho-recojo-tienda__disclaimer");

    // "stores" y "warehouses" se procesan como DELIVERY: la tienda elegida es solo la
    // dirección ("Retiro en <tienda>") y no necesita mapear a un location de Shopify (el
    // fulfillment/stock lo maneja el único location vía envío). Por eso ambos muestran su
    // lista. Solo "disclaimer" no lista (la sucursal se elige en el checkout de Shopify).
    const effectiveMode = PICKUP_CFG.mode;

    if (effectiveMode === "disclaimer") {
        if (listSection) listSection.style.display = "none";
        if (!disclaimerEl) {
            disclaimerEl = document.createElement("div");
            disclaimerEl.className = "enova-carrito-block-despacho-recojo-tienda__disclaimer";
            block.prepend(disclaimerEl);
        }
        disclaimerEl.innerHTML = PICKUP_CFG.disclaimer ||
            "<p>Podrás elegir la tienda de retiro en el siguiente paso.</p>";
        disclaimerEl.style.display = "";
    } else {
        if (disclaimerEl) disclaimerEl.style.display = "none";
        if (listSection) listSection.style.display = "";
        return getPickUpShopList();
    }
}

/* ---- VALIDACIÓN DE STOCK POR MÉTODO DE DESPACHO (según CFG.stockValidation) ----
 * Al elegir delivery o retiro se consulta 1 sola vez el scope=stock con TODAS las
 * variantes del carrito y se pinta un resumen de disponibilidad para ese método.
 * Es informativo: advierte pero NO bloquea el checkout. Si el endpoint falla, se oculta. */

// Contenedor del resumen: se crea una vez, debajo del selector de tipo de entrega.
function getStockSummaryEl() {
    let el = document.querySelector(".enova-stock-summary");
    if (!el) {
        const anchor = document.querySelector(".enova-carrito-block-seleccion-despacho");
        if (!anchor) return null;
        el = document.createElement("div");
        el.className = "enova-stock-summary";
        anchor.insertAdjacentElement("afterend", el);
    }
    return el;
}

// Items del carrito + stock por variante (una sola llamada batch).
/* -------------------------------------------------------------------------
 * MONTO MÍNIMO DE COMPRA (backend: ?scope=settings)
 * ------------------------------------------------------------------------- */

// Carga los ajustes generales. Si falla, no bloquea el flujo (queda sin mínimo).
async function fetchPrecheckoutSettings() {
    try {
        const res = await fetch(
            `${window.Shopify.routes.root}${APP_PROXY}?scope=settings`,
            { method: 'GET', headers: { 'Content-Type': 'application/json' } }
        );
        const data = await res.json();
        if (data && typeof data === 'object' && !Array.isArray(data)) {
            PRECHECKOUT_SETTINGS = data;
        }
    } catch (e) {
        console.warn("No se pudieron cargar los settings del precheckout", e);
    }
}

// Refresca el total del carrito (con descuentos aplicados).
async function refreshCartTotal() {
    try {
        const res = await fetch(window.Shopify.routes.root + 'cart.js', { method: 'GET' });
        const cart = await res.json();
        setCartTotalsFromCart(cart);
    } catch (e) {
        CART_TOTAL = null;
    }
}

function setCartTotalsFromCart(cart) {
    if (!cart) return;
    CART_TOTAL = (cart.total_price || 0) / 100;
    CART_CURRENCY = cart.currency || CART_CURRENCY;
}

// Retorna el mensaje de error si no alcanza el mínimo; null si está OK.
function getMinPurchaseError() {
    const min = PRECHECKOUT_SETTINGS && PRECHECKOUT_SETTINGS.min_purchase_amount;
    if (min === null || min === undefined || min === "") return null;
    if (CART_TOTAL === null) return null;              // sin dato → no bloquear
    if (CART_TOTAL >= Number(min)) return null;

    if (PRECHECKOUT_SETTINGS.min_purchase_message) {
        return PRECHECKOUT_SETTINGS.min_purchase_message;
    }
    const cur = CART_CURRENCY ? `${CART_CURRENCY} ` : "";
    const faltante = (Number(min) - CART_TOTAL).toFixed(2);
    return `El monto mínimo de compra es ${cur}${Number(min).toFixed(2)}. `
         + `Te faltan ${cur}${faltante} para continuar.`;
}

// Muestra el aviso apenas se abre el precheckout (no espera al submit).
function showMinPurchaseWarning() {
    const el = document.querySelector("#enova-message-carrito");
    if (!el) return;
    const err = getMinPurchaseError();
    if (err) {
        el.textContent = err;
        el.classList.add("active");
    }
}

// Carga TODA la config del backend en UNA sola request (?scope=settings): min. de compra,
// total del carrito Y la config de negocio (dispatch/documents/stock/gift/addressMapping).
// Es el mismo fetch que ya se hacía para el mínimo (piggyback: 0 round-trips extra). Al terminar,
// applyBackendConfig deja las variables listas para armar el formulario. Fail-open: si el fetch
// falla, fetchPrecheckoutSettings ya cae al fallback del liquid y el flujo continúa igual.
async function loadBackendConfig() {
    await Promise.all([fetchPrecheckoutSettings(), refreshCartTotal()]);
    applyBackendConfig(PRECHECKOUT_SETTINGS);
    // Recién acá se conocen las reglas de aviso por zona: se engancha el watcher y se
    // pinta una vez, por si el ubigeo ya venía restaurado de una sesión anterior.
    setAddressNoticeWatcher();
}

async function fetchCartStock() {
    const resCart = await fetch(window.Shopify.routes.root + 'cart.js', { method: 'GET' });
    const cart = await resCart.json();
    setCartTotalsFromCart(cart);   // aprovecha la misma request para refrescar el total
    const items = (cart.items || []).map(i => ({
        variant_id: i.variant_id,
        quantity: i.quantity,
        sku: i.sku || "",
        title: i.product_title || i.title || ""
    }));
    if (!items.length) return { items: [], stock: [], demand: null };

    // La fuente la define el backend (?scope=settings -> stockSource). Las dos
    // respuestas traen la misma forma (sku, total/pickup/delivery_available), así
    // que abajo solo cambia por qué campo se busca cada ítem.
    //
    // Los bundles se expanden SOLO en la fuente "apolo": ahí el stock se indexa por
    // SKU y el pack no tiene uno. En la fuente "shopify" el índice es el variant_id,
    // que el pack sí tiene y que Shopify resuelve por su cuenta — no hay nada que
    // expandir y el camino queda exactamente como estaba.
    let lines = items;
    let demand = null;
    let url;
    if (STOCK_SOURCE === "apolo") {
        lines  = await expandCartLines(items);
        demand = buildSkuDemand(lines);
        url = `?scope=stock-local&skus=${encodeURIComponent(Object.keys(demand).join(","))}`;
    } else {
        url = `?scope=stock&variants=${items.map(i => i.variant_id).join(",")}`;
    }

    const res = await fetch(`${window.Shopify.routes.root}${APP_PROXY}${url}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
    });
    const stock = await res.json();
    return { items: lines, stock: Array.isArray(stock) ? stock : [], demand };
}

// Ubica la entrada de stock de un ítem del carrito en la fuente SHOPIFY: el backend
// devuelve id como "gid://shopify/ProductVariant/<id>". La fuente "apolo" se indexa
// por SKU y puede tener varias unidades por línea (bundles), así que su veredicto lo
// resuelve resolveApoloLine.
function findVariantStock(stockList, item) {
    const id = String(item.variant_id);
    return stockList.find(s => String(s.id || "").split("/").pop() === id) || null;
}

// Veredicto de una línea con el stock de Apolo. Cada unidad se compara contra la
// DEMANDA TOTAL de su SKU en el carrito (no contra la cantidad de esta línea): si el
// mismo SKU está suelto y dentro de un pack, validarlos por separado aprobaría dos
// veces el mismo stock. La línea vale lo que su componente peor cubierto.
function resolveApoloLine(item, stockList, demand, isPickup) {
    const units = item.units || [];
    if (!units.length) return { cls: "is-unknown", txt: "Sin información" };

    let peor = null;
    for (const unit of units) {
        const entry = stockList.find(s => s.sku === unit.sku);
        // Un componente que Apolo no conoce deja a toda la línea sin veredicto: es
        // preferible decir "no sé" antes que aprobar un pack a medias.
        if (!entry) return { cls: "is-unknown", txt: "Sin información" };
        const available = Number(isPickup ? entry.pickup_available : entry.delivery_available) || 0;
        const required  = (demand && demand[unit.sku]) || unit.quantity;
        const ratio     = required > 0 ? available / required : 1;
        if (!peor || ratio < peor.ratio) peor = { ratio, available };
    }

    if (peor.ratio >= 1) return { cls: "is-ok", txt: "Disponible" };
    if (peor.available <= 0) {
        return { cls: "is-out", problem: true, txt: isPickup ? "Sin stock para retiro" : "Sin stock para envío" };
    }
    // En un pack el "disponible" es por componente, no por pack: decir "Solo 3
    // disponibles" cuando quedan 3 loncheras y 1 mochila sería engañoso. El conteo se
    // reserva para las líneas de un solo SKU, donde sí significa lo que aparenta.
    if (item.isBundle) return { cls: "is-partial", txt: "Stock insuficiente", problem: true };
    return {
        cls: "is-partial",
        problem: true,
        txt: `Solo ${peor.available} disponible${peor.available === 1 ? "" : "s"}`
    };
}

// ¿Hay UNA sola tienda que tenga todas las unidades de esta línea? Es la pregunta
// correcta para un pack: sus componentes se retiran juntos o no se retiran. Para una
// línea de un solo SKU equivale a "se puede retirar en alguna tienda", que es el
// comportamiento de siempre.
function lineCoveredByOneLocation(units, locations) {
    return (locations || []).some(loc => {
        const items = (loc && loc.items) || [];
        return units.every(u => {
            const entry = items.find(i => i && i.sku === u.sku);
            return !!(entry && entry.ok);
        });
    });
}

// Token de request: si el usuario cambia de método mientras un fetch está en
// vuelo, solo la ÚLTIMA llamada pinta; las respuestas obsoletas se descartan
// (evita el parpadeo de mostrar el resumen del método anterior).
let _stockReqId = 0;

// Resumen de retiro calculado con el stock de APOLO (?scope=pickup-locations).
// En modo "warehouses" el stock por sucursal ya no se puede leer de Shopify: varios
// almacenes pueden publicarse sumados en un mismo location, así que `pickup_available`
// de ?scope=stock sería el agregado y no diría nada por tienda. Acá se usa
// `cart.items[].pickup_anywhere`, que responde exactamente lo que hace falta:
// ¿este producto se puede retirar en ALGUNA tienda?
async function validatePickupWithWarehouses(reqId, el) {
    const { items, locations, cart } = await fetchPickupData();
    if (reqId !== _stockReqId) return;   // llegó una petición más nueva → descartar

    if (!items.length) {
        el.className = "enova-stock-summary"; el.innerHTML = "";
        setCheckoutBlockedByStock(false);
        return;
    }

    const verdict = {};
    (cart.items || []).forEach(i => { verdict[i.sku] = i.pickup_anywhere; });

    let rows = "";
    let hayProblema = false;
    let hayPackDisperso = false;
    items.forEach(item => {
        const units = item.units || [];
        let cls, txt;
        if (!units.length) {
            cls = "is-unknown"; txt = "Sin información";
        } else if (lineCoveredByOneLocation(units, locations)) {
            cls = "is-ok"; txt = "Disponible";
        } else if (units.every(u => verdict[u.sku])) {
            // Cada componente existe en ALGUNA tienda, pero ninguna las tiene todas.
            // El pack se retira entero o no se retira, así que esto es un faltante:
            // marcarlo "Disponible" era la contradicción de decir que sí y bloquear igual.
            cls = "is-partial"; txt = "No está junto en una tienda";
            hayProblema = true; hayPackDisperso = true;
        } else {
            cls = "is-out"; txt = "Sin stock para retiro"; hayProblema = true;
        }

        rows += `<li class="enova-stock-summary__item ${cls}">
                <span class="enova-stock-summary__name">${item.title}</span>
                <span class="enova-stock-summary__qty">x${item.quantity}</span>
                <span class="enova-stock-summary__status">${txt}</span>
            </li>`;
    });

    // Aunque cada producto esté disponible por separado, puede no haber UNA sola
    // tienda que los tenga todos: el retiro es por sucursal, no repartido.
    const sinTiendaUnica = !hayProblema && !cart.any_location_covers_all;

    const problem = hayProblema || sinTiendaUnica;
    // Visibilidad "a voluntad": en "on_problem" solo se muestra si hay faltante
    // (o ninguna tienda cubre todo el carrito).
    if (STOCK_SUMMARY_MODE === "always" || problem) {
        el.className = "enova-stock-summary active";
        el.innerHTML = `
            <h4 class="enova-stock-summary__title">Disponibilidad para retiro en tienda</h4>
            <ul class="enova-stock-summary__list">${rows}</ul>
            ${hayPackDisperso ? `<p class="enova-stock-summary__note">Los productos de un pack se retiran juntos, y ninguna tienda los tiene todos. Cambia el método de entrega o ajusta tu carrito.</p>` : ""}
            ${hayProblema && !hayPackDisperso ? `<p class="enova-stock-summary__note">Sin stock para retiro. Cambia el método de entrega o ajusta tu carrito.</p>` : ""}
            ${sinTiendaUnica ? `<p class="enova-stock-summary__note">Ninguna tienda tiene todos los productos juntos. Cambia el método de entrega o ajusta tu carrito.</p>` : ""}`;
    } else {
        el.className = "enova-stock-summary";
        el.innerHTML = "";
    }

    setCheckoutBlockedByStock(problem);
}

// Valida y pinta el resumen para el modo elegido ("delivery" | "pickup").
async function validateStockForDispatch(dispatchMode) {
    if (!STOCK_ENABLED) return;
    const el = getStockSummaryEl();
    if (!el) return;

    const reqId = ++_stockReqId;

    // En "always" mostramos el loader de una vez; en "on_problem" quedamos ocultos
    // hasta conocer el resultado (evita el parpadeo mostrar→ocultar si todo está OK).
    if (STOCK_SUMMARY_MODE === "always") {
        el.className = "enova-stock-summary active";
        el.innerHTML = `<div class="enova-stock-summary__loading">
                <span class="enova-stock-summary__spinner"></span>Validando disponibilidad…
            </div>`;
    } else {
        el.className = "enova-stock-summary";
        el.innerHTML = "";
    }

    try {
        // Retiro en modo "warehouses" → el veredicto lo da el stock de Apolo.
        // Delivery y el resto de modos siguen consultando Shopify, sin cambios.
        if (dispatchMode === "pickup" && PICKUP_CFG.mode === "warehouses") {
            return await validatePickupWithWarehouses(reqId, el);
        }

        const { items, stock, demand } = await fetchCartStock();
        if (reqId !== _stockReqId) return;   // llegó una petición más nueva → descartar
        if (!items.length) {
            el.className = "enova-stock-summary"; el.innerHTML = "";
            setCheckoutBlockedByStock(false);   // carrito vacío → no bloquear
            return;
        }

        const isPickup = dispatchMode === "pickup";
        let rows = "";
        let hayProblema = false;

        items.forEach(item => {
            let cls, txt;
            if (STOCK_SOURCE === "apolo") {
                // Índice por SKU: una línea puede consumir varios (bundle expandido).
                const v = resolveApoloLine(item, stock, demand, isPickup);
                cls = v.cls; txt = v.txt;
                if (v.problem) hayProblema = true;
            } else {
                const entry = findVariantStock(stock, item);
                const available = entry
                    ? (Number(isPickup ? entry.pickup_available : entry.delivery_available) || 0)
                    : null;

                if (available === null)                 { cls = "is-unknown"; txt = "Sin información"; }
                else if (available >= item.quantity)    { cls = "is-ok";      txt = "Disponible"; }
                else if (available > 0)                    { cls = "is-partial"; txt = `Solo ${available} disponible${available === 1 ? "" : "s"}`; hayProblema = true; }
                else                                    { cls = "is-out";     txt = isPickup ? "Sin stock para retiro" : "Sin stock para envío"; hayProblema = true; }
            }

            rows += `<li class="enova-stock-summary__item ${cls}">
                    <span class="enova-stock-summary__name">${item.title}</span>
                    <span class="enova-stock-summary__qty">x${item.quantity}</span>
                    <span class="enova-stock-summary__status">${txt}</span>
                </li>`;
        });

        // Visibilidad "a voluntad": en "on_problem" solo se muestra si hay faltante.
        if (STOCK_SUMMARY_MODE === "always" || hayProblema) {
            el.className = "enova-stock-summary active";
            el.innerHTML = `
                <h4 class="enova-stock-summary__title">${isPickup ? "Disponibilidad para retiro en tienda" : "Disponibilidad para envío a domicilio"}</h4>
                <ul class="enova-stock-summary__list">${rows}</ul>
                ${hayProblema ? `<p class="enova-stock-summary__note">Sin stock para este despacho. Cambia el método de entrega o ajusta tu carrito.</p>` : ""}`;
        } else {
            el.className = "enova-stock-summary";
            el.innerHTML = "";
        }

        // Bloquea el botón si hay faltantes confirmados para el método elegido.
        // (Independiente de la visibilidad del resumen.)
        setCheckoutBlockedByStock(hayProblema);

    } catch (e) {
        if (reqId !== _stockReqId) return;   // error de una petición obsoleta → ignorar
        // Falla silenciosa: el stock nunca debe romper el checkout (fail-open).
        console.log("No se pudo validar stock:", e);
        el.className = "enova-stock-summary";
        el.innerHTML = "";
        setCheckoutBlockedByStock(false);
    }
}

/* ---- DETECCIÓN DE CAMBIOS EN EL CARRITO NATIVO DE SHOPIFY ----
 * Los botones +/- y "Quitar" del tema modifican el carrito llamando a
 * /cart/change.js | /cart/update.js | /cart/add.js | /cart/clear.js.
 * Interceptamos esas mutaciones (fetch y XHR, según el tema) y, tras un
 * pequeño debounce (Shopify recalcula el carrito de forma asíncrona),
 * re-validamos el stock del método elegido y refrescamos el mínimo de compra.
 * Solo el cart.js de lectura NO dispara nada (no matchea el patrón). */

// Modo actual del selector normalizado a los valores que espera la validación.
function getCurrentDispatchMode() {
    const checked = document.querySelector("input[name=enova-despacho]:checked");
    if (!checked) return null;
    return checked.value === "recojo-tienda" ? "pickup" : "delivery";
}

let _cartChangeTimer = null;
function onNativeCartChanged() {
    clearTimeout(_cartChangeTimer);
    _cartChangeTimer = setTimeout(() => {
        // El total cambió → refresca el mínimo de compra…
        refreshCartTotal().then(showMinPurchaseWarning);
        // …y re-valida el stock del método actualmente seleccionado (si aplica).
        if (STOCK_ENABLED) {
            const mode = getCurrentDispatchMode();
            if (mode) validateStockForDispatch(mode);
        }
        // En modo "warehouses" la lista de tiendas depende del carrito: al cambiar
        // cantidades, una sucursal puede dejar de cubrirlo (o volver a cubrirlo).
        // Se re-consulta solo si el usuario está parado en retiro.
        if (PICKUP_CFG.mode === "warehouses" && getCurrentDispatchMode() === "pickup") {
            renderPickupMode();
        }
    }, 400); // deja que el tema termine de recalcular el carrito antes de re-consultar
}

const CART_MUTATION_RE = /\/cart\/(change|update|add|clear)(\.js)?/i;

// Parchea fetch/XHR una sola vez para escuchar mutaciones del carrito nativo.
function initCartChangeWatcher() {
    // 1) fetch — la vía usada por la mayoría de temas modernos (incl. Minimog)
    if (window.fetch && !window.fetch.__enovaCartPatched) {
        const _origFetch = window.fetch;
        const patched = function (...args) {
            const req = args[0];
            const url = (req && typeof req === "object" && req.url) ? req.url : String(req || "");
            const isMutation = CART_MUTATION_RE.test(url);
            return _origFetch.apply(this, args).then((res) => {
                if (isMutation) onNativeCartChanged();
                return res;
            });
        };
        patched.__enovaCartPatched = true;
        window.fetch = patched;
    }

    // 2) XMLHttpRequest — temas legacy (jQuery.ajax) que aún usan XHR
    if (window.XMLHttpRequest && !XMLHttpRequest.prototype.__enovaCartPatched) {
        const _open = XMLHttpRequest.prototype.open;
        XMLHttpRequest.prototype.open = function (method, url) {
            this.__enovaCartMutation = CART_MUTATION_RE.test(String(url || ""));
            return _open.apply(this, arguments);
        };
        const _send = XMLHttpRequest.prototype.send;
        XMLHttpRequest.prototype.send = function () {
            if (this.__enovaCartMutation) {
                this.addEventListener("load", onNativeCartChanged);
            }
            return _send.apply(this, arguments);
        };
        XMLHttpRequest.prototype.__enovaCartPatched = true;
    }

    // 3) Eventos custom que emiten algunos temas (fallback inocuo si no existen)
    ["cart:updated", "cart:refresh", "cart:change", "ajaxCart:updated"].forEach((evt) => {
        document.addEventListener(evt, onNativeCartChanged);
    });
}

// Dedupe: al re-hacer clic en la opción de despacho YA activa NO se re-dispara el flujo
// de validación (evita ejecuciones repetidas por clics seguidos). Cambiar a la OTRA opción
// sí procede siempre: validateStockForDispatch usa _stockReqId, que descarta las respuestas
// obsoletas, así que la última selección es la que pinta el resumen (nunca queda cruzado).
let _dispatchCurrentMode = null;
function setFormDespacho() {
    for (let buttonDespachoOption of document.querySelectorAll(".enova-despacho-selector-item")) {
        buttonDespachoOption.addEventListener("click", async (ev) => {
            const checked = document.querySelector("input[name=enova-despacho]:checked");
            if (!checked) return;
            if (checked.value === _dispatchCurrentMode) return; // misma opción → no re-dispara
            _dispatchCurrentMode = checked.value;

            for (let buttonDespachoOption of document.querySelectorAll(".enova-despacho-selector-item")) {
                buttonDespachoOption.classList.remove('active');
            }

            if( checked.value === 'recojo-tienda' ) {
                document.querySelector("#enova-despacho-recojo-tienda").classList.add("active");
                document.querySelector("#enova-despacho-shipping").classList.remove("active");

                document.querySelector("#enova-despacho-recojo-tienda").classList.remove("disabled");
                document.querySelector("#enova-despacho-shipping").classList.add("disabled");
                $("#enova-despacho-shipping").css("display", "none");
                $("#enova-despacho-recojo-tienda").css("display", "block");

                // Retiro en tienda: en el pickup NATIVO (disclaimer) se ocultan nombres/apellidos
                // (no pre-llenan). En "stores"/"warehouses" el retiro se procesa como delivery
                // (dirección "Retiro en <tienda>"), así que se muestran TODOS los campos.
                if (isDeliveryLikePickup()) {
                    $(".js-hide-on-pickup").show();
                } else {
                    $(".js-hide-on-pickup").hide();
                }

                // NO se borra el valor del select de fecha: al volver a "envío a domicilio" el
                // select quedaba deseleccionado (vacío). El valor solo se lee en delivery, así
                // que conservarlo es inocuo y preserva lo que el cliente ya había elegido.
                if( document.querySelector("input[name=enova-despacho-tipo]:first-child") ) {
                    document.querySelector("input[name=enova-despacho-tipo]:first-child").checked = true;
                }

                checked.parentElement.classList.add('active');

                renderPickupMode(); // lista de tiendas o disclaimer, según config
                validateStockForDispatch("pickup");

            } else if ( checked.value === 'delivery' ) {
                document.querySelector("#enova-despacho-shipping").classList.add("active");
                document.querySelector("#enova-despacho-recojo-tienda").classList.remove("active");

                document.querySelector("#enova-despacho-shipping").classList.remove("disabled");
                document.querySelector("#enova-despacho-recojo-tienda").classList.add("disabled");
                $("#enova-despacho-shipping").css("display", "block");
                $("#enova-despacho-recojo-tienda").css("display", "none");

                // En envío a domicilio sí se piden nombres/apellidos
                $(".js-hide-on-pickup").show();

                if( document.querySelector(".enova-carrito-block-despacho-recojo-tienda__fecha") ) {
                    document.querySelector(".enova-carrito-block-despacho-recojo-tienda__fecha").classList.remove("active");
                }
                if( document.querySelector("#enova-despacho-recojo-tienda-select-fecha") ) {
                    document.querySelector("#enova-despacho-recojo-tienda-select-fecha").value = null;
                }

                checked.parentElement.classList.add('active');

                // Re-pinta fecha/horario del método vigente: volver de "retiro en tienda" NO
                // dispara el `change` del método, así que sin esto el bloque quedaba vacío.
                const _tipoActual = document.querySelector("input[name=enova-despacho-tipo]:checked");
                const _mActual = _tipoActual ? (_shippingMethodsByCode[_tipoActual.value] || null) : null;
                renderSchedulingForMethod(_mActual);
                renderAgencyForMethod(_mActual);

                validateStockForDispatch("delivery");
            } else {
                checked.parentElement.classList.add('active');
            }
        });
    }
}

function setFormBillingDoc() {
    for (let buttonDespachoOption of document.querySelectorAll(".enova-billing-item")) {
        buttonDespachoOption.addEventListener("click", (ev) => {
            for (let buttonDespachoOption of document.querySelectorAll(".enova-billing-item")) {
                buttonDespachoOption.classList.remove('active');
            }
          
            const checkedDoc = document.querySelector("input[name=enova-billing-doc]:checked");
            if (!checkedDoc) return;

            const docBlock = document.querySelector("#enova-billing-doc");
            // La visibilidad de este bloque la gobiernan las clases (#enova-billing-doc.active).
            // Se limpia cualquier `display` inline heredado del restore: un inline gana sobre el
            // CSS y dejaba el bloque pegado en pantalla al cambiar a Boleta (switch muerto).
            if (docBlock) docBlock.style.display = "";

            // El despacho puede NO estar elegido aún (con 2 opciones no hay preselección).
            // Antes esto era `...:checked").value` directo y reventaba con null → TypeError,
            // abortando el handler y rompiendo el switch.
            const dispatchChecked = document.querySelector("input[name=enova-despacho]:checked");
            const isPickup = !!dispatchChecked && dispatchChecked.value === 'recojo-tienda';

            if (checkedDoc.value === 'factura') {
                if (docBlock) {
                    docBlock.classList.add("active");
                    docBlock.classList.remove("disabled");
                }
                if (isPickup) {
                    jQuery("#formulario--billing-address_checkbox").prop("checked", false);
                    jQuery(".enova-carrito-block-despacho-shipping__formulario--billing-address_addressform").css("display", "block");
                    jQuery(".enova-carrito-block-despacho-shipping__formulario--billing-address_checkbox").css("display", "none");
                }

            } else if (checkedDoc.value === 'boleta') {
                if (docBlock) {
                    docBlock.classList.remove("active");
                    docBlock.classList.add("disabled");
                }
                jQuery("#formulario--billing-address_checkbox").prop("checked", true);
                jQuery(".enova-carrito-block-despacho-shipping__formulario--billing-address_addressform").css("display", "none");
                jQuery(".enova-carrito-block-despacho-shipping__formulario--billing-address_checkbox").css("display", "block");
            }
            checkedDoc.parentElement.classList.add('active');
        });
    }
}

function setStoresEventClick() {
    for (let buttonDespachoOption of document.querySelectorAll(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item")) {
        buttonDespachoOption.addEventListener("click", (ev) => {
            for (let buttonDespachoOption of document.querySelectorAll(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item")) {
                buttonDespachoOption.classList.remove('active');
            }
          
            if(document.querySelector("input[name=enova-despacho-recojo-tienda-item]:checked")) {
                if(document.querySelector(".enova-carrito-block-despacho-recojo-tienda__fecha")) {
                    document.querySelector(".enova-carrito-block-despacho-recojo-tienda__fecha").classList.add("active");
                }
                if( document.querySelector("#enova-despacho-recojo-tienda-select-fecha") ) {
                    document.querySelector("#enova-despacho-recojo-tienda-select-fecha").value = null;
                }
                document.querySelector("input[name=enova-despacho-recojo-tienda-item]:checked").parentElement.classList.add('active');
            }
        });
    }
}

function setStoreListFilter() {
    jQuery("#enova-carrito-block-despacho-recojo__filtro").on("change", (ev) => {
        let filter_store_selected = ev.target.value;
        getPickUpShopList(filter_store_selected);
    });
}

function calculateShippingMethodByUbigeoSelected() {
    if( document.querySelector("#enova-carrito-block-despacho-shipping__distrito") ) {
        document.querySelector("#enova-carrito-block-despacho-shipping__distrito").addEventListener("change", () => {
             $(".enova-carrito-block-despacho-shipping__fecha").css("display", "none");
             despachoMethodShippingLoading('loading');

            if(
                document.querySelector("#enova-carrito-block-despacho-shipping__distrito") &&
                (
                    document.querySelector("#enova-carrito-block-despacho-shipping__distrito").value !== "0" &&
                    document.querySelector("#enova-carrito-block-despacho-shipping__distrito").value !== "Seleccione..."
                )
            ) {
                getResponseCartItems(true)
                    .then((carritoItemsListE) => {

                        {
                            despachoMethodShippingLoading('loading');
                            let SelectedDepartamentoUBIGEO = jQuery("#enova-carrito-block-despacho-shipping__distrito option:selected").data("ubigeo"); 
                            let totalWeight = 0

                            var carrito_productos = carritoItemsListE.map((el_producto) => {
                                // Las keys llevan prefijo "_" (privadas en Shopify, no se muestran en el template)
                                let selectedAttr_peso = el_producto.attributes.find((item_key) => item_key.key === "_peso");
                                let selectedAttr_sku = el_producto.attributes.find((item_key) => item_key.key === "_sku");
                                let pesoVal = selectedAttr_peso ? selectedAttr_peso.value : 0;
                                totalWeight = totalWeight + ( pesoVal ? parseFloat(pesoVal) : 0 )
                                return ({
                                    "sku": selectedAttr_sku ? selectedAttr_sku.value : "",
                                    "quantity": el_producto.quantity,
                                    "volumen_unit": null,
                                    "weight_unit": pesoVal ? parseFloat(pesoVal) : 0,
                                    "position": null
                                });
                            });
                            totalWeight = totalWeight / 1000
                            
                            let productCart = JSON.stringify(carrito_productos);
                            
                            // total_cart (con descuentos): necesario para el envío gratis sobre monto
                            // (total_cart_enabled + total_cart_limit); sin él el backend recibe 0 y nunca
                            // marca is_free_shipping. CART_TOTAL lo refrescó getResponseCartItems arriba.
                            let totalCart = CART_TOTAL != null ? CART_TOTAL : 0;
                            let urlBuilder = `?scope=district-calc-rates&ubigeo=${SelectedDepartamentoUBIGEO}&products=${productCart}&weight=${totalWeight}&total_cart=${totalCart}`;

                            if(SelectedDepartamentoUBIGEO) {
                                fetch(`${window.Shopify.routes.root}${APP_PROXY}${ urlBuilder }`, {
                                    method: 'GET',
                                    headers:{ 'Content-Type': 'application/json' }
                                })
                                .then(res => res.json())
                                .then(response => {
                                    console.log('Success:', response);
                                    SetRenderShippingMethodsListOption(response);

                                    if (getCustomerData("shipping_method")) {
                                        let shippingMethodType = getCustomerData("shipping_method");
                                        $(`input[name="enova-despacho-tipo"][value="${shippingMethodType}"]`).prop('checked', true).trigger('change');
                                    }
                                    despachoMethodShippingLoading(null);
                                })
                                .catch(error => {
                                    console.error('Error:', error);
                                    despachoMethodShippingLoading(null);
                                });
                            } else {
                                alert("Debe seleccionar un Distrito Valido");
                            }
                        }
                    })
                    .catch((err) => {
                        console.log("err", err);
                        despachoMethodShippingLoading(null);
                    });
    
            } else {
                despachoMethodShippingLoading(null);
            }
        });
    }
}

// El aviso por zona se recalcula ante cualquier cambio del ubigeo (departamento,
// provincia o distrito). Delegado con namespace: sobrevive al repintado de los <option>,
// no se duplica al re-invocar, y responde tanto al change nativo (dispatchEvent) como al
// de jQuery (.trigger('change')) que usa el restore.
// Recalcula TODO lo que depende del ubigeo en el bloque de dirección: el aviso por zona
// y los placeholders de Dirección/Referencia. Ambos usan el mismo código de ubigeo elegido.
function renderAddressUbigeoDependent() {
    renderAddressNotice();
    renderAddressPlaceholders();
}
function setAddressNoticeWatcher() {
    const sel = "#enova-carrito-block-despacho-shipping__departamento,"
              + "#enova-carrito-block-despacho-shipping__provincia,"
              + "#enova-carrito-block-despacho-shipping__distrito";
    jQuery(document)
        .off("change.enovaAddressNotice", sel)
        .on("change.enovaAddressNotice", sel, renderAddressUbigeoDependent);
    renderAddressUbigeoDependent();
}

function calculateShippingMethodToShowOption() {
    // Handler DELEGADO con jQuery (no addEventListener) por dos razones:
    //  1) La lista de métodos se re-renderiza con .html(): la delegación sobrevive al reemplazo.
    //  2) El restore hace $(...).trigger('change'), que NO dispara handlers nativos de
    //     addEventListener — solo los de jQuery. Con esto responde a ambos casos.
    // El namespace + .off evitan handlers duplicados al re-invocar esta función.
    jQuery(document)
        .off("change.enovaScheduling", "input[name=enova-despacho-tipo]")
        .on("change.enovaScheduling", "input[name=enova-despacho-tipo]", function () {
            const checked = document.querySelector("input[name=enova-despacho-tipo]:checked");
            if (!checked) return;
            // Presence-based: el bloque de fecha/horario aparece solo si el método elegido
            // trae config de scheduling. renderSchedulingForMethod lo puebla u oculta.
            const _m = _shippingMethodsByCode[checked.value] || null;
            renderSchedulingForMethod(_m);
            renderAgencyForMethod(_m);
        });
}

function setRenderCartFormKeypressValidation() {
    jQuery('.page-content form').on('keyup keypress', function(e) {
        var keyCode = e.keyCode || e.which;
        if (keyCode === 13) { 
          e.preventDefault();
          return false;
        }
    });

    jQuery("#enova-billing-documento-type").on("change", (ev) => {
        jQuery("#enova-billing-documento-number").val("");
        $("p.text-has-error.text-typedoc").remove();
        document.querySelector("#enova-billing-documento-number").classList.remove("input-has-error");
    });

    jQuery("#enova-billing-documento-number").on("keypress", (ev) => {
        const selected = jQuery("#enova-billing-documento-type").val();
        const doc = (DOC_CFG.person || []).find(d => d.value === selected);
        if (!doc) return;
        const currentLength = ev.currentTarget.value.length;
        if (currentLength >= doc.maxLen) { ev.preventDefault(); return; }
        const regex = doc.numeric ? /^[0-9]$/ : /^[a-zA-Z0-9]$/;
        if (!regex.test(ev.key)) ev.preventDefault();
    });

    jQuery("#enova-billing-telefono").on("keypress", (ev) => {
        if (!/[0-9]/.test(ev.key)) ev.preventDefault();
    });

    // Celular del destinatario (regalo): solo numérico, igual que el del comprador
    jQuery("#enova-regalo-telefono").on("keypress", (ev) => {
        if (!/[0-9]/.test(ev.key)) ev.preventDefault();
    });

    // Documento de empresa (factura): numérico o alfanumérico según el país
    jQuery("#enova-billing-doc-ruc").on("keypress", (ev) => {
        const comp = DOC_CFG.company;
        const regex = (comp && comp.numeric === false) ? /^[a-zA-Z0-9]$/ : /^[0-9]$/;
        if (!regex.test(ev.key)) ev.preventDefault();
    });

    $("[for='enova-billing-telefono']").text("Celular");
}

function cartStep1() {
    let buttonCartCheckoutStep = document.querySelector(".enova_cart_button_step1");
    if (buttonCartCheckoutStep) {
        buttonCartCheckoutStep.addEventListener("click", (ev) => {
            let blockCartStep = document.querySelector(".enova-block-carrito-main");
            let blockCart = document.querySelector("#MinimogCart");
            document.querySelector("input[name=enova-despacho]:first-child").click();
        });
    }
}

function initSetFormDataUbigeosAvailable() {
    setResetSelectorOptions('departaments');
    setResetSelectorOptions('provinces');
    setResetSelectorOptions('distrits');
    setResetSelectorOptions('departaments', true);
    setResetSelectorOptions('provinces', true);
    setResetSelectorOptions('distrits', true);

    populate("departaments", { country: "1", departament: null, district: null })
    .then((result) => {
        let departmentsList = result ;
        setSelectorOptions("departaments", departmentsList);
        setSelectorOptions("departaments", departmentsList, true);
        
        let region = getCustomerData("region");
        if (region) {
            $("#enova-carrito-block-despacho-shipping__departamento").val(region).change();
        }
    })
    .catch((err) => console.log("err ubigeo selector departaments", err));

    jQuery("#enova-carrito-block-despacho-shipping__departamento").on("change", () => {
        setResetSelectorOptions('provinces');
        setResetSelectorOptions('distrits');

        let SelectedDepartamentoID = jQuery("#enova-carrito-block-despacho-shipping__departamento option:selected").data("id"); 

        populate("provinces", { country: "1", departament: SelectedDepartamentoID, district: null })
        .then((result) => {
            let provincesList = result ;
            setSelectorOptions("provinces", provincesList);

            let city = getCustomerData("province");
            if (city && $("#enova-carrito-block-despacho-shipping__departamento").val() == getCustomerData("region")) {
                $("#enova-carrito-block-despacho-shipping__provincia").val(city).change();
            }
        })
        .catch((err) => console.log("err ubigeo selector provinces", err));
    });

    jQuery("#enova-carrito-block-despacho-shipping__provincia").on("change", () => {
        setResetSelectorOptions('distrits');
        
        let SelectedDepartamentoID = jQuery("#enova-carrito-block-despacho-shipping__departamento option:selected").data("id"); 
        let SelectedProvinciaID = jQuery("#enova-carrito-block-despacho-shipping__provincia option:selected").data("id"); 
        
        populate("distrits", { country: "1", departament: SelectedDepartamentoID, district: SelectedProvinciaID })
        .then((result) => {
            let districtList = result ;
            setSelectorOptions("distrits", districtList);

            let locality = getCustomerData("district");
            if (locality && $("#enova-carrito-block-despacho-shipping__provincia").val() == getCustomerData("province")) {
                $("#enova-carrito-block-despacho-shipping__distrito").val(locality);
                const distrito = document.querySelector("#enova-carrito-block-despacho-shipping__distrito");
                distrito.dispatchEvent(new Event("change", { bubbles: true }));
                $(`input[name="enova-despacho-tipo"][value="${getCustomerData("shipping_method")}"]`).prop('checked', true).trigger('change');
            }
        })
        .catch((err) => console.log("err ubigeo selector distrits", err));
    });

    jQuery("#enova-carrito-block-despacho-billing__departamento").on("change", () => {
        setResetSelectorOptions('provinces', true);
        setResetSelectorOptions('distrits', true);

        let SelectedDepartamentoID = jQuery("#enova-carrito-block-despacho-billing__departamento option:selected").data("id"); 

        populate("provinces", { country: "1", departament: SelectedDepartamentoID, district: null })
        .then((result) => setSelectorOptions("provinces", result, true))
        .catch((err) => console.log("err ubigeo selector provinces", err));
    });

    jQuery("#enova-carrito-block-despacho-billing__provincia").on("change", () => {
        setResetSelectorOptions('distrits', true);
        
        let SelectedDepartamentoID = jQuery("#enova-carrito-block-despacho-billing__departamento option:selected").data("id"); 
        let SelectedProvinciaID = jQuery("#enova-carrito-block-despacho-billing__provincia option:selected").data("id"); 
        
        populate("distrits", { country: "1", departament: SelectedDepartamentoID, district: SelectedProvinciaID })
        .then((result) => setSelectorOptions("distrits", result, true))
        .catch((err) => console.log("err ubigeo selector distrits", err));
    });

    jQuery("#formulario--billing-address_checkbox").on("change", (ev) => {
        if(!jQuery("#formulario--billing-address_checkbox").prop("checked")) {
            jQuery(".enova-carrito-block-despacho-shipping__formulario--billing-address_addressform").css("display", "block");
        } else {
            jQuery(".enova-carrito-block-despacho-shipping__formulario--billing-address_addressform").css("display", "none");
        }
    });
}

/* -------------------------------------------------------------------------
 * 6. FLUJO DE CHECKOUT
 * ------------------------------------------------------------------------- */
function handleCheckoutSubmit(ev) {
    ev.preventDefault();

    if( !jQuery("#terms_conditions").prop("checked") ) {
        document.querySelector("#enova-message-carrito").textContent = "Debes aceptar los términos y condiciones";
        document.querySelector("#enova-message-carrito").classList.add("active");
        return false;
    }

    // Bloqueo por stock: no permite pasar al checkout si el método elegido no tiene disponibilidad
    if (_stockBlocked) {
        document.querySelector("#enova-message-carrito").textContent = "Algunos productos no tienen stock disponible para este método. Elige otro método de entrega.";
        document.querySelector("#enova-message-carrito").classList.add("active");
        return false;
    }

    // Monto mínimo de compra (aplica a delivery y pickup por igual)
    const minPurchaseError = getMinPurchaseError();
    if (minPurchaseError) {
        document.querySelector("#enova-message-carrito").textContent = minPurchaseError;
        document.querySelector("#enova-message-carrito").classList.add("active");
        return false;
    }

    $("#enova-message-carrito").removeClass("active");
    document.querySelector("#enova-message-carrito").innerHTML = "";

    let type_document = document.querySelector("input[name=enova-billing-doc]:checked") ? document.querySelector("input[name=enova-billing-doc]:checked").value : '';

    function getShippingMatch() {
        let addressSelected = document.querySelector("#enova-despacho-direccion").value;
        let formateAddress = document.querySelector("#enova-despacho-direccion") ? addressSelected : "";
        return formateAddress;
    }

    var obj_params = {
        attributes: {
            'country': 'Peru',
            'dispatch_mode': document.querySelector("input[name=enova-despacho]:checked") ? (document.querySelector("input[name=enova-despacho]:checked").value === "recojo-tienda" ? "pickup" : document.querySelector("input[name=enova-despacho]:checked").value) : "",
            'region': document.querySelector("#enova-carrito-block-despacho-shipping__departamento  option:checked") ? document.querySelector("#enova-carrito-block-despacho-shipping__departamento  option:checked").textContent.trim() : "",
            'province': document.querySelector("#enova-carrito-block-despacho-shipping__provincia  option:checked") ? document.querySelector("#enova-carrito-block-despacho-shipping__provincia  option:checked").textContent.trim() : "",
            'district': document.querySelector("#enova-carrito-block-despacho-shipping__distrito  option:checked") ? document.querySelector("#enova-carrito-block-despacho-shipping__distrito  option:checked").textContent.trim() : "",
            'ubigeo': document.querySelector("#enova-carrito-block-despacho-shipping__distrito option:checked") ? document.querySelector("#enova-carrito-block-despacho-shipping__distrito option:checked").dataset.code : "",
            'address': getShippingMatch(),
            'reference': document.querySelector("#enova-despacho-referencia") ? document.querySelector("#enova-despacho-referencia").value : '',
            'receipt_type': type_document,
            'email': document.querySelector("#enova-billing-email") ? document.querySelector("#enova-billing-email").value : "", 
            'first_name': document.querySelector("#enova-billing-name") ? document.querySelector("#enova-billing-name").value : "",
            'last_name': document.querySelector("#enova-billing-lastName") ? document.querySelector("#enova-billing-lastName").value : "", 
            'phone': document.querySelector("#enova-billing-telefono") ? document.querySelector("#enova-billing-telefono").value : "",
            'document_type': document.querySelector("#enova-billing-documento-type") ? document.querySelector("#enova-billing-documento-type").value : "",
            'document_number': document.querySelector("#enova-billing-documento-number") ? document.querySelector("#enova-billing-documento-number").value : ""
        }
    };

    // Fecha/horario solo si el método elegido requiere scheduling (envío programado).
    // Usa el mismo normalizador que el render, para no depender del shape del backend.
    const _checkedTipo = document.querySelector("input[name=enova-despacho-tipo]:checked");
    const _selectedMethod = _checkedTipo ? _shippingMethodsByCode[_checkedTipo.value] : null;
    if (getMethodScheduling(_selectedMethod)) {
        obj_params['attributes']['delivery_date'] = document.querySelector("#enova-despacho-delivery-select-fecha").value;
        obj_params['attributes']['delivery_time'] = document.querySelector("#enova-despacho-delivery-select-horario").value;
    }

    // Datos de la agencia (nombre + dirección), solo cuando el método elegido lo pide y la
    // opción está prendida. Viajan como note_attributes; no se mapean a la dirección de Shopify.
    if (methodNeedsAgencyName(_selectedMethod)) {
        const _agNombre    = document.querySelector("#enova-despacho-agencia-nombre");
        const _agDireccion = document.querySelector("#enova-despacho-agencia-direccion");
        obj_params['attributes']['agency_name']    = _agNombre    ? _agNombre.value.trim()    : "";
        obj_params['attributes']['agency_address'] = _agDireccion ? _agDireccion.value.trim() : "";
    }

    if(document.querySelector("input[name=enova-billing-doc]:checked") && document.querySelector("input[name=enova-billing-doc]:checked").value === 'factura') {
        obj_params['attributes']['company_document'] = document.querySelector("#enova-billing-doc-ruc").value;
        obj_params['attributes']['company_name'] = document.querySelector("#enova-billing-doc-razonsocial").value;
    }

    // Regalo (solo si la opción está habilitada). Queda como note_attributes; NO se envía al
    // buyerIdentity/deliveryAddress del checkout. is_gift siempre presente; datos solo si aplica.
    if (GIFT_ENABLED) {
        const _isGift = !!(document.querySelector("#enova-regalo-check") && document.querySelector("#enova-regalo-check").checked);
        obj_params.attributes['is_gift'] = _isGift ? "true" : "false";
        if (_isGift) {
            obj_params.attributes['gift_recipient_name']  = document.querySelector("#enova-regalo-nombre") ? document.querySelector("#enova-regalo-nombre").value.trim() : "";
            obj_params.attributes['gift_recipient_phone'] = document.querySelector("#enova-regalo-telefono") ? document.querySelector("#enova-regalo-telefono").value.trim() : "";
            // Dedicatoria: opcional. Si va vacía, la poda de vacíos la descarta del pedido.
            obj_params.attributes['gift_message'] = document.querySelector("#enova-regalo-dedicatoria") ? document.querySelector("#enova-regalo-dedicatoria").value.trim() : "";
        }
    }

    if( document.querySelector("input[name=enova-despacho]:checked") && document.querySelector("input[name=enova-despacho]:checked").value === "delivery" ) {
        obj_params.attributes['shipping_method'] = document.querySelector("input[name=enova-despacho-tipo]:checked") ? document.querySelector("input[name=enova-despacho-tipo]:checked").value : '';
    }
    
    if( document.querySelector("input[name=enova-despacho]:checked") && document.querySelector("input[name=enova-despacho]:checked").value === "recojo-tienda" ) {
        const _storeInput = document.querySelector(".enova-carrito-block-despacho-recojo-tienda__list-tiendas--item input:checked");
        const _storeTitle = _storeInput ? jQuery(_storeInput).parent().find(".enova-tienda-titulo").text() : "";
        const _storeDir   = _storeInput ? jQuery(_storeInput).parent().find(".enova-tienda-direccion").text() : "";
        const _isDeliveryLikePickup = isDeliveryLikePickup();

        if (_isDeliveryLikePickup) {
            // Retiro "stores"/"warehouses": se procesa como DELIVERY con todos los datos. Se
            // CONSERVAN nombres/apellidos y la dirección viaja como "Retiro en <tienda>".
            obj_params.attributes['address'] = _storeInput ? `Retiro en ${_storeTitle}` : "";
        } else {
            // Retiro NATIVO de Shopify (disclaimer): no aplican nombres/apellidos (no pre-llenan).
            delete obj_params.attributes['first_name'];
            delete obj_params.attributes['last_name'];
            obj_params.attributes['address'] = _storeInput ? `Recojo Tienda: ${_storeDir}` : "";
        }

        obj_params.attributes['region']   = _storeInput ? _storeInput.dataset.departamento : '';
        obj_params.attributes['province'] = _storeInput ? _storeInput.dataset.provincia : '';
        obj_params.attributes['district'] = _storeInput ? _storeInput.dataset.distrito : '';
        obj_params.attributes['ubigeo']   = _storeInput ? _storeInput.dataset.ubigeo : '';
        obj_params.attributes['reference'] = '-';
        obj_params.attributes['pickup_store'] = _storeTitle || '';

        if( obj_params && obj_params.attributes && obj_params.attributes['pickup_date'] && obj_params.attributes['delivery_time'] ) {
            obj_params.attributes['reference'] = `Fecha: ${obj_params.attributes['pickup_date']}, Horario: ${obj_params.attributes['delivery_time']}`;
        }
    }

    // Ubigeo sin elegir (placeholder) → "" para que cuente como vacío en validación y pintado.
    ['region', 'province', 'district'].forEach(k => {
        const v = obj_params.attributes[k];
        if (v === "Seleccione..." || v === "Seleccione" || v === "0") obj_params.attributes[k] = "";
    });

    let formValid = true;
    // first_name/last_name NO van en comunes: en pickup nativo se ocultan (no pre-llenan).
    const fieldsCommon = ['email', 'phone', 'document_type', 'document_number', 'country', 'dispatch_mode', 'receipt_type'];
    const fieldsDelivery = [...fieldsCommon, 'first_name', 'last_name', 'region', 'province', 'district', 'ubigeo', 'address', 'reference', 'shipping_method'];
    const fieldsPickup   = [...fieldsCommon];
    // Retiro "warehouses" se procesa como delivery: se exigen nombres y los datos de la tienda
    // elegida (region/province/district/ubigeo/address ya vienen del store), menos shipping_method
    // (en retiro no hay selector de método de envío).
    const fieldsWarehousePickup = [...fieldsCommon, 'first_name', 'last_name', 'region', 'province', 'district', 'ubigeo', 'address'];

    const dispatchMode = obj_params.attributes['dispatch_mode'] || 'delivery';
    const isDeliveryLikePickupNow = dispatchMode === 'pickup' && isDeliveryLikePickup();
    const fieldsToValidate = dispatchMode === 'pickup'
        ? (isDeliveryLikePickupNow ? fieldsWarehousePickup : fieldsPickup)
        : fieldsDelivery;

    const $inputPhone     = $("#enova-billing-telefono");
    const $selectDocType  = $("#enova-billing-documento-type"); 
    const $inputDocNum    = $("#enova-billing-documento-number");
    const $msgContainer   = $("#enova-message-carrito");
    const $radioFactura   = $('input[name="enova-billing-doc"]:checked');
    const $inputRucFactura= $('#enova-billing-doc-ruc');

    $msgContainer.removeClass("active").text("");
    $inputDocNum.removeClass("input-has-error");
    $(".text-has-error.text-typedoc").remove();

    fieldsToValidate.forEach(key => {
        let value = obj_params.attributes[key];
        if (!value || value.trim() === '') {
            formValid = false;
        }
    });

    if ($inputPhone.val().length < 9) {
        formValid = false;
    }

    const docType = $selectDocType.val(); 
    const docNum  = $inputDocNum.val();
    const docLen  = docNum.length;
    let docMessage = "";
    let isDocValid = true;

    const personDoc = (DOC_CFG.person || []).find(d => d.value === docType);
    if (personDoc) {
        const okLen = docLen >= personDoc.minLen && docLen <= personDoc.maxLen;
        const okChars = personDoc.numeric ? /^[0-9]+$/.test(docNum) : /^[a-zA-Z0-9]+$/.test(docNum);
        if (!okLen || !okChars) {
            const lenTxt = personDoc.minLen === personDoc.maxLen
                ? `${personDoc.minLen}`
                : `entre ${personDoc.minLen} y ${personDoc.maxLen}`;
            docMessage = `El ${personDoc.label} debe tener ${lenTxt} caracteres${personDoc.numeric ? " numéricos" : " alfanuméricos"}.`;
            isDocValid = false;
        }
    }

    if (!isDocValid) {
        formValid = false;
        $msgContainer.text(docMessage).addClass("active");
        $inputDocNum.addClass("input-has-error");
        $inputDocNum.parent().append(`<p class='text-has-error text-typedoc'>${docMessage}</p>`);
    }

    if ($radioFactura.val() === "factura") {
        const comp = DOC_CFG.company;
        const rucVal = String($inputRucFactura.val() || "");
        let okComp;
        if (comp) {
            const okLen = rucVal.length >= comp.minLen && rucVal.length <= comp.maxLen;
            const okChars = comp.numeric ? /^[0-9]+$/.test(rucVal) : /^[a-zA-Z0-9]+$/.test(rucVal);
            okComp = okLen && okChars;
        } else {
            okComp = rucVal.trim().length > 0;
        }
        if (!okComp) {
            $inputRucFactura.addClass("input-has-error");
            formValid = false;
        }
    }

    // Envío programado: la FECHA siempre es obligatoria. El HORARIO solo lo es si el día
    // elegido ofrece ventanas; si ese día no tiene (slot oculto), no se exige.
    const _schedSel = getMethodScheduling(_selectedMethod);
    if (_schedSel) {
        const $fechaProg   = $("#enova-despacho-delivery-select-fecha");
        const $horarioProg = $("#enova-despacho-delivery-select-horario");
        const diaSel  = String($fechaProg.val() || "").trim();
        const okFecha = !!diaSel;

        const hayVentanas = okFecha && getWindowsForDay(_schedSel, diaSel).length > 0;
        const okHorario   = !hayVentanas || !!String($horarioProg.val() || "").trim();

        $fechaProg.toggleClass("input-has-error", !okFecha);
        $horarioProg.toggleClass("input-has-error", !okHorario);
        if (!okFecha || !okHorario) formValid = false;
    }

    // Agencia: nombre y dirección son obligatorios solo cuando el recuadro está visible, o sea
    // cuando la opción está prendida Y el método elegido es de tipo agencia.
    if (methodNeedsAgencyName(_selectedMethod)) {
        const $agNombre    = $("#enova-despacho-agencia-nombre");
        const $agDireccion = $("#enova-despacho-agencia-direccion");
        const okNombre    = !!String($agNombre.val()    || "").trim();
        const okDireccion = !!String($agDireccion.val() || "").trim();
        $agNombre.toggleClass("input-has-error", !okNombre);
        $agDireccion.toggleClass("input-has-error", !okDireccion);
        if (!okNombre || !okDireccion) formValid = false;
    }

    // Regalo: si está marcado, el nombre del destinatario y su celular (9 díg) son obligatorios.
    if (GIFT_ENABLED && obj_params.attributes['is_gift'] === "true") {
        const $giftName  = $("#enova-regalo-nombre");
        const $giftPhone = $("#enova-regalo-telefono");
        $giftPhone.parent().find(".text-has-error.text-gift-phone").remove();

        if (!($giftName.val() || "").trim()) {
            $giftName.addClass("input-has-error");
            formValid = false;
        } else {
            $giftName.removeClass("input-has-error");
        }

        if (($giftPhone.val() || "").trim().length < 9) {
            $giftPhone.addClass("input-has-error");
            $giftPhone.parent().append("<p class='text-has-error text-gift-phone'>El celular del destinatario debe tener 9 dígitos</p>");
            formValid = false;
        } else {
            $giftPhone.removeClass("input-has-error");
        }
    }

    if(formValid) {
        // Higiene del payload: no enviar note_attributes vacíos (evita atributos en blanco en el
        // pedido). Se corre DESPUÉS de validar/resaltar para no afectar la comparación con "".
        // Los valores no vacíos se conservan (incl. is_gift:"false", que sí es un dato).
        Object.keys(obj_params.attributes).forEach(k => {
            const v = obj_params.attributes[k];
            if (v === null || v === undefined || String(v).trim() === "") {
                delete obj_params.attributes[k];
            }
        });

        document.querySelector("#enova_cart-data-submit").setAttribute("aria-busy", "true");
        checkoutButtonLoader(true);

        fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },    
            body: JSON.stringify(obj_params)
        })
        .then(response => response.json())
        .then(response => {
            document.querySelector("#enova-message-carrito").classList.remove("active");

            serviceCart2CheckoutStoreFrontAPI(obj_params)
                .then((result) => {
                    if(result && result.message && result.name === "Error") {
                        checkoutButtonLoader(false);
                        throw result;
                    }
                    
                    // Manejo del WebUrl de redirección obtenido desde GraphQL
                    if(result && result.checkout && result.checkout.webUrl) {
                        checkoutButtonLoader(true);
                        setLocalStorageCustomerData();

                        let url_checkout_ = `${result.checkout.id}`;
                        // Construcción de la URL limpia basada en el ID del Checkout
                        url_checkout_ = `${CHECKOUT_BASE}/cart/c/${url_checkout_.split("gid://shopify/Cart/")[1] || url_checkout_.split("gid://shopify/Checkout/")[1]}&channel=buy_button&_fd=0`;

                        // UTMs → checkout (el cupón ya viaja dentro del carrito vía cartCreate)
                        url_checkout_ = appendCheckoutParams(url_checkout_);

                        window.location.href = url_checkout_;
                    } else {
                        throw result;
                    }
                })
                .catch((err) => {
                    console.log("Fallo el pre-checkout, aplicando fallback a checkout normal", err);
                    checkoutButtonLoader(false);

                    fetch(window.Shopify.routes.root + 'cart.js', {
                        method: 'GET',
                        headers: { 'Content-Type': 'application/json' }
                    })
                    .then(response => response.json())
                    .then(response => {
                        // Fallback: el token viene del carrito NATIVO, que ya trae el cupón aplicado
                        // por el cliente → viaja solo al checkout. Aquí solo anexamos UTMs.
                        let fallbackUrl = `${CHECKOUT_BASE}/checkouts/cn/${response.token}`;
                        fallbackUrl = appendCheckoutParams(fallbackUrl);
                        window.location.href = fallbackUrl;
                    })
                    .catch((err2) => {
                        document.querySelector("#enova-message-carrito").textContent = "No se pudo crear el pedido, algunos productos no están disponibles, por favor vuelve a intentar";
                        document.querySelector("#enova-message-carrito").classList.add("active");
                    });
                });
        })
        .catch((error) => {
            console.error('CART Error:', error);
        });

    } else {
        if (obj_params.attributes.email === "") document.querySelector("#enova-billing-email").classList.add("input-has-error");
        else document.querySelector("#enova-billing-email").classList.remove("input-has-error");
        
        if (obj_params.attributes.first_name === "") document.querySelector("#enova-billing-name").classList.add("input-has-error");
        else document.querySelector("#enova-billing-name").classList.remove("input-has-error");
        
        if (obj_params.attributes.last_name === "") document.querySelector("#enova-billing-lastName").classList.add("input-has-error");
        else document.querySelector("#enova-billing-lastName").classList.remove("input-has-error");
        
        if (obj_params.attributes.phone === "") {
          document.querySelector("#enova-billing-telefono").classList.add("input-has-error");
          if ( $(".text-has-error.text-phone").length == 0 ) $("#enova-billing-telefono").parent().append("<p class='text-has-error text-phone'>El celular debe tener 9 dígitos</p>");
        } else {
          if ( document.querySelector("#enova-billing-telefono").value.length < 9 ) {
            document.querySelector("#enova-billing-telefono").classList.add("input-has-error");
            if ( $(".text-has-error.text-phone").length == 0 ) $("#enova-billing-telefono").parent().append("<p class='text-has-error text-phone'>El celular debe tener 9 dígitos</p>");
          } else {
            document.querySelector("#enova-billing-telefono").classList.remove("input-has-error");
            $("p.text-has-error.text-phone").remove();
          }
        }
        
        if (obj_params.attributes["document_type"] === "") {
          document.querySelector("#enova-billing-documento-type").classList.add("input-has-error");
        } else {
          document.querySelector("#enova-billing-documento-type").classList.remove("input-has-error");
        }

        if (obj_params.attributes["document_number"] === "") {
          document.querySelector("#enova-billing-documento-number").classList.add("input-has-error");
        } else {
          document.querySelector("#enova-billing-documento-number").classList.remove("input-has-error");
          if(typeof validateDocumentTypeForm === "function") validateDocumentTypeForm();
        }
        
        if (obj_params.attributes["shipping_method"] === "") {
            document.querySelector(".enova-carrito-block-despacho-shipping-tipo__delivery--title").classList.add("text-has-error");
        } else {
            document.querySelector(".enova-carrito-block-despacho-shipping-tipo__delivery--title").classList.remove("text-has-error");
        }

        if (obj_params.attributes["dispatch_mode"] === "delivery") {
          if (obj_params.attributes.address === "") document.querySelector("#enova-despacho-direccion").classList.add("input-has-error");
          else document.querySelector("#enova-despacho-direccion").classList.remove("input-has-error");
          
          if (obj_params.attributes.reference === "") document.querySelector("#enova-despacho-referencia").classList.add("input-has-error");
          else document.querySelector("#enova-despacho-referencia").classList.remove("input-has-error");
          
          document.querySelector("#enova-carrito-block-despacho-shipping__departamento").classList.toggle("input-has-error", obj_params.attributes.region === "");
          document.querySelector("#enova-carrito-block-despacho-shipping__provincia").classList.toggle("input-has-error", obj_params.attributes.province === "");
          document.querySelector("#enova-carrito-block-despacho-shipping__distrito").classList.toggle("input-has-error", obj_params.attributes.district === "");
        }

        if( document.querySelector("input[name=enova-despacho]:checked") ) {
            document.querySelector("#enova-despacho-delivery-option").parentNode.parentNode.parentNode.classList.remove("input-has-error");
            jQuery("#enova-despacho-delivery-option").parent().parent().parent().find(".msg-error-not-selected-option").hide();
        } else {
            document.querySelector("#enova-despacho-delivery-option").parentNode.parentNode.parentNode.classList.add("input-has-error");
            if( jQuery("#enova-despacho-delivery-option").parent().parent().parent().find(".msg-error-not-selected-option")[0] ) {
                jQuery("#enova-despacho-delivery-option").parent().parent().parent().find(".msg-error-not-selected-option").show();
            } else {
                jQuery("#enova-despacho-delivery-option").parent().parent().parent().append(`<div class="msg-error-not-selected-option">Debes seleccionar tu tipo de Despacho</div>`);
            }
        }

        if( document.querySelector("input[name=enova-billing-doc]:checked") ) {
            document.querySelector("#enova-despacho-billing-boleta").parentNode.parentNode.parentNode.classList.remove("input-has-error");
            jQuery("#enova-despacho-billing-boleta").parent().parent().parent().find(".msg-error-not-selected-option").hide();
        } else {
            document.querySelector("#enova-despacho-billing-boleta").parentNode.parentNode.parentNode.classList.add("input-has-error");
            if( jQuery("#enova-despacho-billing-boleta").parent().parent().parent().find(".msg-error-not-selected-option")[0] ) {
                jQuery("#enova-despacho-billing-boleta").parent().parent().parent().find(".msg-error-not-selected-option").show();
            } else {
                jQuery("#enova-despacho-billing-boleta").parent().parent().parent().append(`<div class="msg-error-not-selected-option">Debes seleccionar tu tipo de comprobante</div>`);
            }
        }

        if( document.querySelector("input[name=enova-despacho-tipo]:checked") ) {
            document.querySelector(".enova-carrito-block-despacho-shipping-tipo__delivery--list").parentNode.parentNode.parentNode.classList.remove("input-has-error");
            jQuery(".enova-carrito-block-despacho-shipping-tipo__delivery--list").find(".msg-error-not-selected-option").hide();
        } else {
            document.querySelector(".enova-carrito-block-despacho-shipping-tipo__delivery--list").parentNode.parentNode.parentNode.classList.add("input-has-error");
            if( jQuery(".enova-carrito-block-despacho-shipping-tipo__delivery--list").find(".msg-error-not-selected-option")[0] ) {
                jQuery(".enova-carrito-block-despacho-shipping-tipo__delivery--list").find(".msg-error-not-selected-option").show();
            } else {
                jQuery(".enova-carrito-block-despacho-shipping-tipo__delivery--list").append(`<div class="msg-error-not-selected-option">Debes seleccionar metodo de envio.</div>`);
            }
        }

        if (jQuery('input[name="enova-billing-doc"]:checked').val() === "factura") {
            var _comp = DOC_CFG.company || { label: "documento", minLen: 0, maxLen: 0, numeric: true };
            var _rucVal = String($("#enova-billing-doc-ruc").val() || "");
            var _okLen = _rucVal.length >= _comp.minLen && _rucVal.length <= _comp.maxLen;
            var _okChars = _comp.numeric ? /^[0-9]+$/.test(_rucVal) : /^[a-zA-Z0-9]+$/.test(_rucVal);
            if (!_okLen || !_okChars) {
                document.querySelector("#enova-billing-doc-ruc").classList.add("input-has-error");
                var _lenTxt = _comp.minLen === _comp.maxLen ? `${_comp.maxLen}` : `${_comp.minLen} a ${_comp.maxLen}`;
                var message_validation = `El campo ${_comp.label} debe tener ${_lenTxt} caracteres`;
                if ($("#enova-billing-doc-ruc").parent().find('.text-has-error').length === 0) {
                    $("#enova-billing-doc-ruc").parent().append(`<p class='text-has-error text-typedoc'>${message_validation}</p>`);
                }
            } else {
                document.querySelector("#enova-billing-doc-ruc").classList.remove("input-has-error");
                $("#enova-billing-doc-ruc").parent().find('.text-has-error.text-typedoc').remove();
            }
        }

        if ( jQuery('input[name="enova-billing-doc"]:checked').val() === "factura" ) {
            if ( jQuery("#enova-billing-doc-razonsocial").val() === "" ) {
                document.querySelector("#enova-billing-doc-razonsocial").classList.add("input-has-error");
            } else {
                document.querySelector("#enova-billing-doc-razonsocial").classList.remove("input-has-error");
            }
        }

        document.querySelector("#enova_cart-data-submit").setAttribute("aria-busy", "false");
        document.querySelector("#enova-message-carrito").textContent = "Debes completar las casillas faltantes en rojo";
        document.querySelector("#enova-message-carrito").classList.add("active");
    }
}

// Construye el select de tipo de documento y el campo de empresa según el país (config).
function renderDocumentsFromConfig() {
    const $sel = jQuery("#enova-billing-documento-type");
    if ($sel.length && DOC_CFG.person && DOC_CFG.person.length) {
        let opts = '<option selected disabled value="">Tipo Documento</option>';
        DOC_CFG.person.forEach(d => { opts += `<option value="${d.value}">${d.label}</option>`; });
        $sel.html(opts);
        const maxLen = Math.max.apply(null, DOC_CFG.person.map(d => d.maxLen));
        jQuery("#enova-billing-documento-number").attr("maxlength", maxLen);
    }
    if (DOC_CFG.company) {
        jQuery("#enova-billing-doc-ruc")
            .attr("placeholder", `Nº de ${DOC_CFG.company.label}`)
            .attr("maxlength", DOC_CFG.company.maxLen);
    }
}

/* -------------------------------------------------------------------------
 * 7. INICIALIZADOR
 * ------------------------------------------------------------------------- */
// Oculta el skeleton y revela el formulario (ya configurado). Idempotente.
function revealPrecheckout() {
    const main = document.querySelector(".enova-block-carrito-main");
    if (main) main.classList.remove("is-loading");
}

document.addEventListener('DOMContentLoaded', async function() {
    try {
        // 1) Config del backend PRIMERO (con fallback al liquid). El skeleton se muestra mientras
        //    tanto (clase is-loading en el HTML). Piggyback en el settings que ya se pedía.
        await loadBackendConfig();

        // 2) Con la config lista, se arma el formulario.
        renderDocumentsFromConfig();
        setFormDespacho();
        setFormBillingDoc();
        setFormGift();          // toggle del destinatario (listener antes del restore)
        setStoresEventClick();
        calculateShippingMethodByUbigeoSelected();
        calculateShippingMethodToShowOption();
        setRenderCartFormKeypressValidation();
        cartStep1();

        setInitCustomerData();
        applyDispatchConfig(); // aplica flags delivery/pickup (al final: manda sobre el restore)
        applyGiftConfig();     // muestra/oculta el bloque de regalo según la config
        showMinPurchaseWarning(); // config y total ya cargados: solo avisa si no alcanza el mínimo
        initCartChangeWatcher(); // re-valida stock/mínimo cuando cambia el carrito nativo
        initPersistOnChange();   // autosave del formulario (no perder datos al volver del checkout)
    } catch (e) {
        console.warn("Error inicializando el precheckout", e);
    } finally {
        // 3) Pase lo que pase, se revela el formulario (fail-open: nunca dejar el skeleton pegado).
        revealPrecheckout();
    }
});

// Al volver con el botón "atrás" del navegador, la página se restaura desde el bfcache
// EXACTAMENTE como se dejó: con el overlay "Procesando" activo y el botón bloqueado.
// El script no se re-ejecuta, así que reseteamos el estado de carga al restaurarse.
window.addEventListener('pageshow', function(ev) {
    if (ev.persisted || document.querySelector(".enova-loading-overlay.active")) {
        checkoutButtonLoader(false);
    }
});

var setCheckerCartDiscountLabel = setInterval(() => {
    // El botón "Ir a pagar" + el checkbox de T&C los INYECTA el JS. Antes esto se ataba a
    // que la URL incluyera "cart", así que en el minicarrito (drawer, abierto desde una página
    // de producto/colección) nunca aparecía. Ahora se dispara por PRESENCIA del precheckout en
    // el DOM (su punto de anclaje real), así funciona igual en /cart y en el minicarrito.
    const anchor = document.querySelector(".cart__recap") || document.querySelector(".enova-carrito-block");
    if (anchor && !(document.querySelector("#enova_cart-data-submit")) ) {
        setFakeButtonCart();
        clearInterval(setCheckerCartDiscountLabel);

        jQuery(".enova-carrito-block").addClass("active");
        jQuery("#enova_cart-data-submit").show();

        initSetFormDataUbigeosAvailable();
    }
}, 1000);